import LangKeys from "./keys";

const pa = {
  [LangKeys.reminders_collect_faster]: "3 ਗੁਣਾ ਤੇਜ਼ੀ ਨਾਲ ਪੈਸੇ ਵਸੂਲੋ",
  [LangKeys.reminders_total_dues]: "ਕੁੱਲ ਬਕਾਇਆ",
  [LangKeys.reminders_all_customers]: "ਸਾਰੇ ਗਾਹਕ",
  [LangKeys.reminders_all]: "ਸਾਰੇ",
  [LangKeys.reminders_customers]: "ਗਾਹਕ",
  [LangKeys.reminders_suppliers]: "ਸਪਲਾਇਰ",
  [LangKeys.reminders_search_placeholder]: "ਗਾਹਕ ਦਾ ਨਾਮ ਜਾਂ ਮੋਬਾਈਲ ਨੰਬਰ ਖੋਜੋ...",
  [LangKeys.reminders_pending_balance]: "ਬਕਾਇਆ ਰਕਮ",
  [LangKeys.reminders_sent]: "ਭੇਜਿਆ ਗਿਆ",
  [LangKeys.reminders_whatsapp]: "WhatsApp",
  [LangKeys.reminders_sms]: "SMS",
  [LangKeys.reminders_call]: "ਕਾਲ ਕਰੋ",
  [LangKeys.reminders_date]: "ਮਿਤੀ",
  [LangKeys.reminders_all_up_to_date]: "ਸਭ ਅਪ-ਟੂ-ਡੇਟ ਹੈ",
  [LangKeys.reminders_no_overdue_heading]: "ਕੋਈ ਮਿਆਦ ਪੁੱਗਾ ਗਾਹਕ ਨਹੀਂ ਮਿਲਿਆ",
  [LangKeys.reminders_no_overdue_sub]: "ਬਹੁਤ ਵਧੀਆ! ਸਾਰੇ ਗਾਹਕਾਂ ਦਾ ਭੁਗਤਾਨ ਸਮੇਂ ਸਿਰ ਹੈ।",
  [LangKeys.reminders_view_all_customers]: "ਸਾਰੇ ਗਾਹਕ ਵੇਖੋ",
  [LangKeys.reminders_no_due_today_heading]: "ਅੱਜ ਕੋਈ ਦੇਣਦਾਰੀ ਨਹੀਂ ਹੈ",
  [LangKeys.reminders_no_due_today_sub]: "ਅੱਜ ਲਈ ਕੋਈ ਰੀਮਾਈਂਡਰ ਨਿਰਧਾਰਤ ਨਹੀਂ ਹੈ।",
  [LangKeys.reminders_no_upcoming_heading]: "ਕੋਈ ਆਉਣ ਵਾਲਾ ਰੀਮਾਈਂਡਰ ਨਹੀਂ ਹੈ",
  [LangKeys.reminders_no_upcoming_sub]: "ਸਮੇਂ ਸਿਰ ਰੀਮਾਈਂਡਰ ਭੇਜਣ ਲਈ ਕਲੈਕਸ਼ਨ ਮਿਤੀ ਸੈੱਟ ਕਰੋ।",
  [LangKeys.reminders_no_customers_found]: "ਕੋਈ ਗਾਹਕ ਨਹੀਂ ਮਿਲਿਆ",
  [LangKeys.reminders_no_customers_matched]: "ਤੁਹਾਡੀ ਖੋਜ ਨਾਲ ਕੋਈ ਗਾਹਕ ਨਹੀਂ ਮਿਲਿਆ।",
  [LangKeys.reminders_auto_reminder_active]: "ਆਟੋ ਰੀਮਾਈਂਡਰ ਐਕਟਿਵ",
  [LangKeys.reminders_overdue_by]: "ਮਿਆਦ ਪੁੱਗੀ",
  [LangKeys.reminders_due_in]: "ਬਾਕੀ ਦਿਨ",
  [LangKeys.reminders_days]: "ਦਿਨ",
  [LangKeys.reminders_day]: "ਦਿਨ",
  [LangKeys.reminders_set_collection_date]: "ਕਲੈਕਸ਼ਨ ਮਿਤੀ ਸੈੱਟ ਕਰੋ",
  [LangKeys.reminders_collect_faster_sub]: "ਗਾਹਕਾਂ ਤੋਂ ਤੇਜ਼ੀ ਨਾਲ ਭੁਗਤਾਨ ਪ੍ਰਾਪਤ ਕਰੋ",
  [LangKeys.reminders_pending_amount_filter]: "ਬਕਾਇਆ ਰਕਮ ਫਿਲਟਰ (₹)",
  [LangKeys.reminders_highest_amount]: "ਸਭ ਤੋਂ ਵੱਧ ਰਕਮ",
  [LangKeys.reminders_oldest_dues]: "ਸਭ ਤੋਂ ਪੁਰਾਣਾ ਬਕਾਇਆ",
  [LangKeys.reminders_by_due_date]: "ਮਿਤੀ ਅਨੁਸਾਰ",
  [LangKeys.reminders_min]: "ਘੱਟੋ-ਘੱਟ",
  [LangKeys.reminders_max]: "ਵੱਧ ਤੋਂ ਵੱਧ",
  [LangKeys.reminders_to]: "ਤੋਂ",
  [LangKeys.reminders_customers_selected]: "ਗਾਹਕ ਚੁਣੇ ਗਏ",
  [LangKeys.reminders_total]: "ਕੁੱਲ",
  [LangKeys.reminders_set_due_date_selected]: "ਚੁਣੇ ਗਏ ਗਾਹਕਾਂ ਦੀ ਮਿਤੀ ਸੈੱਟ ਕਰੋ",
  [LangKeys.reminders_date_lbl]: "ਮਿਤੀ",
  [LangKeys.reminders_wa_sent_toast]: "{name} ਨੂੰ WhatsApp ਰੀਮਾਈਂਡਰ ਭੇਜਿਆ ਗਿਆ!",
  [LangKeys.reminders_date_updated]: "ਰੀਮਾਈਂਡਰ ਮਿਤੀ ਸਫਲਤਾਪੂਰਵਕ ਸੁਰੱਖਿਅਤ ਕੀਤੀ ਗਈ!",

  [LangKeys.reminders_bulk_success]: "ਸਫਲਤਾਪੂਰਵਕ ਰੀਮਾਈਂਡਰ ਭੇਜਿਆ ਗਿਆ!",

  [LangKeys.reminders_sending]: "ਸੁਰੱਖਿਅਤ ਹੋ ਰਿਹਾ ਹੈ...",

  [LangKeys.reminders_cloud_wa]: "ਕਲਾਊਡ WhatsApp API",

  [LangKeys.reminders_direct_wa]: "ਸਿੱਧਾ WhatsApp (ਮੁਫ਼ਤ ਵੈੱਬ/ਐਪ)",

  [LangKeys.reminders_no_pending_desc]: "ਜਦੋਂ ਕਿਸੇ ਗਾਹਕ ਤੋਂ ਪੈਸੇ ਲੈਣੇ ਹੋਣਗੇ, ਤਾਂ ਉਹ ਇੱਥੇ ਰੀਮਾਈਂਡਰ ਸੂਚੀ ਵਿੱਚ ਦਿਖਾਈ ਦੇਣਗੇ।",

  [LangKeys.reminders_no_pending]: "ਕੋਈ ਬਕਾਇਆ ਰੀਮਾਈਂਡਰ ਨਹੀਂ ਹੈ",

  [LangKeys.reminders_clear_date]: "ਮਿਤੀ ਹਟਾਓ",

  [LangKeys.reminders_save_date]: "ਮਿਤੀ ਸੁਰੱਖਿਅਤ ਕਰੋ",

  [LangKeys.reminders_time_lbl]: "ਸਮਾਂ",

  [LangKeys.reminders_chip_custom]: "ਕਸਟਮ ਮਿਤੀ",

  [LangKeys.reminders_chip_1month]: "1 ਮਹੀਨੇ ਬਾਅਦ",

  [LangKeys.reminders_chip_15days]: "15 ਦਿਨ ਬਾਅਦ",

  [LangKeys.reminders_chip_1week]: "1 ਹਫ਼ਤੇ ਬਾਅਦ",

  [LangKeys.reminders_chip_3days]: "3 ਦਿਨ ਬਾਅਦ",

  [LangKeys.reminders_chip_tomorrow]: "ਕੱਲ੍ਹ",

  [LangKeys.reminders_chip_today]: "ਅੱਜ",

  [LangKeys.reminders_days_left]: "ਦਿਨ ਬਾਕੀ",

  [LangKeys.reminders_days_overdue]: "ਦਿਨ ਲੇਟ",

  [LangKeys.reminders_not_sent]: "ਅਜੇ ਤੱਕ ਨਹੀਂ ਭੇਜਿਆ ਗਿਆ",

  [LangKeys.reminders_last_sent]: "ਆਖਰੀ ਵਾਰ ਭੇਜਿਆ",

  [LangKeys.reminders_auto_reminder_desc]: "ਨਿਰਧਾਰਤ ਮਿਤੀ ਅਤੇ ਸਮੇਂ 'ਤੇ ਆਪਣੇ ਆਪ ਰੀਮਾਈਂਡਰ ਭੇਜੋ",

  [LangKeys.reminders_auto_reminder]: "ਆਟੋ ਰੀਮਾਈਂਡਰ (Auto Send)",

  [LangKeys.reminders_send_all_whatsapp]: "ਸਾਰਿਆਂ ਨੂੰ ਇਕੱਠੇ ਵਟਸਐਪ ਭੇਜੋ",

  [LangKeys.reminders_send_whatsapp]: "WhatsApp ਰੀਮਾਈਂਡਰ ਭੇਜੋ",

  [LangKeys.reminders_change_due_date]: "ਤਾਰੀਖ ਬਦਲੋ",

  [LangKeys.reminders_set_due_date]: "ਨਿਯਤ ਮਿਤੀ ਸੈੱਟ ਕਰੋ",

  [LangKeys.reminders_selected]: "ਚੁਣੇ ਗਏ",

  [LangKeys.reminders_select_all]: "ਸਾਰੇ ਚੁਣੋ",

  [LangKeys.reminders_search_hint]: "ਗਾਹਕ ਦਾ ਨਾਮ ਜਾਂ ਮੋਬਾਈਲ ਨੰਬਰ ਖੋਜੋ...",

  [LangKeys.reminders_no_date_tab]: "ਤਾਰੀਖ ਬਿਨਾਂ",

  [LangKeys.reminders_upcoming_tab]: "ਆਉਣ ਵਾਲੇ",

  [LangKeys.reminders_overdue_tab]: "ਓਵਰਡਿਊ",

  [LangKeys.reminders_today_tab]: "ਅੱਜ",

  [LangKeys.reminders_all_tab]: "ਸਾਰੇ",

  [LangKeys.reminders_no_date]: "ਤਾਰੀਖ ਤੋਂ ਬਿਨਾਂ",

  [LangKeys.reminders_upcoming]: "ਆਉਣ ਵਾਲੇ",

  [LangKeys.reminders_due_today]: "ਅੱਜ ਨਿਯਤ",

  [LangKeys.reminders_overdue]: "ਮਿਆਦ ਪੁੱਗੀ",

  [LangKeys.reminders_total_outstanding]: "ਕੁੱਲ ਬਕਾਇਆ",

  [LangKeys.reminders_subtitle]: "ਸਮਾਰਟ ਬਹੀਖਾਤਾ ਨਾਲ ਆਪਣਾ ਕਾਰੋਬਾਰ ਵਧਾਓ।",

  [LangKeys.reminders_title]: "ਭੁਗਤਾਨ ਰੀਮਾਈਂਡਰ",

  [LangKeys.processing]: "ਕਾਰਵਾਈ ਜਾਰੀ ਹੈ...",

  [LangKeys.business_owner]: "ਕਾਰੋਬਾਰ ਮਾਲਕ",

  [LangKeys.moxpal_khata]: "ਮੋਕਸਪਾਲ ਖਾਤਾ",

  [LangKeys.failed_load_dashboard]: "ਡੈਸ਼ਬੋਰਡ ਡਾਟਾ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",

  [LangKeys.delete_confirm]: "ਕੀ ਤੁਸੀਂ ਵਾਕਈ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",

  [LangKeys.today]: "ਅੱਜ",

  [LangKeys.add_bill_terms_conditions_hint]: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ...",

  [LangKeys.stock]: "ਸਟਾਕ",

  [LangKeys.add_bill_item_price]: "ਕੀਮਤ",

  [LangKeys.add_bill_item_name]: "ਆਈਟਮ ਦਾ ਨਾਮ",

  [LangKeys.parties]: "ਪਾਰਟੀਆਂ",

  [LangKeys.address_area]: "ਇਲਾਕਾ / ਲੈਂਡਮਾਰਕ",

  [LangKeys.address_flat_no]: "ਮਕਾਨ / ਦੁਕਾਨ ਨੰ.",

  [LangKeys.search_items_hint]: "ਆਈਟਮ ਖੋਜੋ...",

  [LangKeys.no_items_found]: "ਕੋਈ ਆਈਟਮ ਨਹੀਂ ਮਿਲੀ",

  [LangKeys.loading]: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",

  [LangKeys.edit_price_dialog_title]: "ਕੀਮਤ ਬਦਲੋ",

  [LangKeys.photos]: "ਫੋਟੋਆਂ",

  [LangKeys.notes]: "ਨੋਟਸ",

  [LangKeys.save_expense]: "ਖਰਚਾ ਸੰਭਾਲੋ",

  [LangKeys.add_bill_payment_details]: "ਭੁਗਤਾਨ ਵੇਰਵੇ",

  [LangKeys.fields]: "ਫੀਲਡਾਂ",

  [LangKeys.unpaid]: "ਬਾਕੀ (Unpaid)",

  [LangKeys.item_name_required]: "ਆਈਟਮ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",

  [LangKeys.delete_confirmation]: "ਕੀ ਤੁਸੀਂ ਵਾਕਈ ਇਸਨੂੰ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",

  [LangKeys.online_private]: "ਨਿੱਜੀ (Private)",

  [LangKeys.online_active]: "ਆਨਲਾਈਨ ਮਾਰਕੀਟ ਵਿੱਚ ਸਰਗਰਮ",


    [LangKeys.app_name]: "ਮੋਕਸ਼ਪਾਲ ਖਾਤਾ",
    [LangKeys.header_subtitle]: "ਸਮਾਰਟ ਬੁੱਕਕੀਪਿੰਗ ਨਾਲ ਆਪਣੇ ਕਾਰੋਬਾਰ ਨੂੰ ਅੱਗੇ ਵਧਾਓ।",

    // SHARED KHATA
    [LangKeys.shared_khata__summary]: "ਖਾਤਾ ਸਾਰਾਂਸ਼",
    [LangKeys.customer_name]: "ਗਾਹਕ ਦਾ ਨਾਮ",
    [LangKeys.mobile_no]: "ਮੋਬਾਈਲ ਨੰਬਰ",
    [LangKeys.transaction_history]: "ਲੈਣ-ਦੇਣ ਦਾ ਇਤਿਹਾਸ",
    [LangKeys.total_debit]: "ਕੁੱਲ ਡੈਬਿਟ",
    [LangKeys.total_credit]: "ਕੁੱਲ ਕ੍ਰੈਡਿਟ",
    [LangKeys.net_balance]: "ਕੁੱਲ ਬਕਾਇਆ",
    [LangKeys.date]: "ਮਿਤੀ",
    [LangKeys.credit]: "ਕ੍ਰੈਡਿਟ",
    [LangKeys.debit]: "ਡੈਬਿਟ",
    [LangKeys.balance]: "ਬਕਾਇਆ",
    [LangKeys.note]: "ਨੋਟ",
    [LangKeys.call_support]: "ਸਹਾਇਤਾ ਨੂੰ ਕਾਲ ਕਰੋ",
    [LangKeys.invalid_link]: "ਇਹ ਲਿੰਕ ਅਵੈਧ ਹੈ ਜਾਂ ਮਿਆਦ ਪੁੱਗ ਗਈ ਹੈ।",
    [LangKeys.footer]: "ਇਹ ਇੱਕ ਕੰਪਿਊਟਰ ਦੁਆਰਾ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਸਟੇਟਮੈਂਟ ਹੈ ਅਤੇ ਇਸਨੂੰ ਕਿਸੇ ਦਸਤਖਤ ਦੀ ਲੋੜ ਨਹੀਂ ਹੈ।",

    // COMMON
    [LangKeys.settings]: "ਸੈਟਿੰਗਾਂ",
    [LangKeys.settings_subtitle]: "ਆਪਣੀ ਐਪਲੀਕੇਸ਼ਨ ਅਤੇ ਕਾਰੋਬਾਰੀ ਤਰਜੀਹਾਂ ਦਾ ਪ੍ਰਬੰਧਨ ਕਰੋ",
    [LangKeys.language]: "ਭਾਸ਼ਾ",
    [LangKeys.select_language]: "ਭਾਸ਼ਾ ਚੁਣੋ",
    [LangKeys.close]: "ਬੰਦ ਕਰੋ",
    [LangKeys.save]: "ਸੇਵ ਕਰੋ",
    [LangKeys.retry]: "ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    [LangKeys.profile]: "ਪ੍ਰੋਫਾਈਲ ਸੰਪਾਦਿਤ ਕਰੋ",
    [LangKeys.logout]: "ਲੌਗਆਉਟ",
    [LangKeys.version]: "ਸੰਸਕਰਣ",
    [LangKeys.copyright]: "ਕਾਪੀਰਾਈਟ © ਮੋਕਸਪਾਲ ਖੱਟਾ",
    [LangKeys.total]: "ਕੁੱਲ",
    [LangKeys.required_field]: "ਇਹ ਫੀਲਡ ਲਾਜ਼ਮੀ ਹੈ",
    [LangKeys.product]: "ਉਤਪਾਦ",

    [LangKeys.message_language]: "SMS ਭਾਸ਼ਾ",
    [LangKeys.follow_app]: "ਐਪ ਅਨੁਸਾਰ",

    [LangKeys.hindi]: "ਹਿੰਦੀ",
    [LangKeys.english]: "ਅੰਗ੍ਰੇਜ਼ੀ",
    [LangKeys.hinglish]: "ਹਿੰਗਲਿਸ਼",

    [LangKeys.gujarati]: "ਗੁਜਰਾਤੀ",
    [LangKeys.marathi]: "ਮਰਾਠੀ",
    [LangKeys.punjabi]: "ਪੰਜਾਬੀ",
    [LangKeys.tamil]: "ਤਮਿਲ",
    [LangKeys.telugu]: "ਤੇਲਗੂ",

    // SETTINGS PAGE
    [LangKeys.business_settings]: "ਕਾਰੋਬਾਰੀ ਸੈਟਿੰਗਾਂ",
    [LangKeys.business_settings_desc]: "ਕਾਰੋਬਾਰੀ ਪ੍ਰੋਫਾਈਲ, ਲੋਗੋ ਅਤੇ GST ਵੇਰਵੇ",
    [LangKeys.staff_permissions]: "ਸਟਾਫ ਅਤੇ ਇਜਾਜ਼ਤਾਂ",
    [LangKeys.staff_permissions_desc]: "ਸਟਾਫ ਦੀ ਪਹੁੰਚ ਅਤੇ ਇਜਾਜ਼ਤਾਂ ਦਾ ਪ੍ਰਬੰਧਨ ਕਰੋ",
    [LangKeys.backup_information]: "ਬੈਕਅੱਪ ਜਾਣਕਾਰੀ",
    [LangKeys.backup_information_desc]: "ਖਾਤਾ ਡੇਟਾ ਨਿਰਯਾਤ ਅਤੇ ਰੀਸਟੋਰ ਕਰੋ",
    [LangKeys.delete_khata]: "ਖਾਤਾ ਮਿਟਾਓ",
    [LangKeys.delete_khata_desc]: "ਸਾਰੇ ਕਾਰੋਬਾਰੀ ਡੇਟਾ ਨੂੰ ਸਥਾਈ ਤੌਰ ਤੇ ਹਟਾਓ",
    [LangKeys.app_update]: "ਐਪ ਅੱਪਡੇਟ",
    [LangKeys.app_update_desc]: "ਨਵੀਨਤਮ ਸੰਸਕਰਣ ਲਈ ਜਾਂਚ ਕਰੋ",
    [LangKeys.app_up_to_date]: "ਐਪ ਨਵੀਂਤਮ ਹੈ",
    [LangKeys.failed_to_check_for_update]: "ਅਪਡੇਟ ਚੈੱਕ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.whatsapp_service]: "ਵਟਸਐਪ ਅਲਰਟਸ ਅਤੇ ਕਰੈਡਿਟਸ",
    [LangKeys.whatsapp_service_desc]: "ਗਾਹਕਾਂ ਨੂੰ ਆਟੋਮੈਟਿਕ ਭੁਗਤਾਨ ਰਿਮਾਈਂਡਰ ਭੇਜੋ ਅਤੇ ਕਰੈਡਿਟਸ ਮੈਨੇਜ ਕਰੋ",

    /* ================= Whatsapp SMS Credtits PAGE ================= */
    [LangKeys.whatsapp_credits]: "ਵਟਸਐਪ ਕ੍ਰੈਡਿਟਸ",
    [LangKeys.available_credits]: "ਉਪਲਬਧ ਕ੍ਰੈਡਿਟਸ",
    [LangKeys.whatsapp_balance]: "ਵਟਸਐਪ ਮੈਸੇਜ ਬੈਲੈਂਸ",
    [LangKeys.used]: "ਵਰਤੋਂ",
    [LangKeys.credits]: "ਕ੍ਰੈਡਿਟਸ",
    [LangKeys.proceed_to_pay]: "ਭੁਗਤਾਨ ਕਰੋ",
    [LangKeys.recharge_plans]: "ਰੀਚਾਰਜ ਪਲਾਨ",
    [LangKeys.off]: "ਬੰਦ",

    [LangKeys.load_failed]: "ਲੋਡ ਫੇਲ ਹੋ ਗਿਆ",
    [LangKeys.toggle_failed]: "ਟੌਗਲ ਫੇਲ ਹੋ ਗਿਆ",
    [LangKeys.order_failed]: "ਆਰਡਰ ਫੇਲ ਹੋ ਗਿਆ",
    [LangKeys.payment_error]: "ਪੇਮੈਂਟ ਐਰਰ ਆਇਆ",
    [LangKeys.payment_failed]: "ਪੇਮੈਂਟ ਫੇਲ ਹੋ ਗਿਆ",
    [LangKeys.verification_failed]: "ਵੈਰੀਫਿਕੇਸ਼ਨ ਫੇਲ ਹੋ ਗਿਆ",
    [LangKeys.recharge_successful]: "ਰੀਚਾਰਜ ਸਫਲ ਹੋ ਗਿਆ",
    [LangKeys.total_purchased]: "ਕੁੱਲ ਖਰੀਦੇ ਗਏ",

    /* ================= BACKUP INFORMATION ================= */
    [LangKeys.backup_info_text]: "ਜਦੋਂ ਤੁਹਾਡਾ ਫ਼ੋਨ ਇੰਟਰਨੈੱਟ ਨਾਲ ਕਨੈਕਟ ਹੁੰਦਾ ਹੈ ਤਾਂ ਤੁਹਾਡਾ ਡੇਟਾ ਆਪਣੇ ਆਪ ਬੈਕਅੱਪ ਹੋ ਜਾਂਦਾ ਹੈ। ਜੇਕਰ ਤੁਸੀਂ ਆਪਣਾ ਫ਼ੋਨ ਫਾਰਮੈਟ ਕਰਦੇ ਹੋ ਜਾਂ ਐਪ ਨੂੰ ਮਿਟਾਉਂਦੇ ਹੋ, ਤਾਂ ਬਸ ਆਪਣੇ ਰਜਿਸਟਰਡ ਨੰਬਰ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਦੁਬਾਰਾ ਲੌਗਇਨ ਕਰੋ। ਤੁਹਾਡਾ ਡੇਟਾ ਆਪਣੇ ਆਪ ਰੀਸਟੋਰ ਹੋ ਜਾਵੇਗਾ।",
    [LangKeys.last_backup_at]: "ਆਖਰੀ ਬੈਕਅੱਪ",

    /* ================= DELETE / KHATA ================= */
    [LangKeys.delete_warning_text]: "ਤੁਸੀਂ ਇਸ ਕਾਰੋਬਾਰ ਨੂੰ ਮਿਟਾਉਣ ਜਾ ਰਹੇ ਹੋ। ਤੁਹਾਡਾ ਸਾਰਾ ਡੇਟਾ ਰੀਸਾਈਕਲ ਬਿਨ ਵਿੱਚ ਭੇਜ ਦਿੱਤਾ ਜਾਵੇਗਾ। ਤੁਸੀਂ ਇਸਨੂੰ 30 ਦਿਨਾਂ ਦੇ ਅੰਦਰ ਰੀਸਟੋਰ ਕਰ ਸਕਦੇ ਹੋ।",
    [LangKeys.delete_placeholder]: "ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਕਾਰੋਬਾਰ ਦਾ ਨਾਮ ਟਾਈਪ ਕਰੋ",
    [LangKeys.delete_button]: "ਮਿਟਾਓ",
    [LangKeys.delete_name_mismatch]: "ਕਾਰੋਬਾਰ ਦਾ ਨਾਮ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ।",

    // ================= KHATA =================
    [LangKeys.my_khata]: "ਮੇਰਾ ਖਾਤਾ",
    [LangKeys.search_customer]: "ਗਾਹਕ ਖੋਜੋ",
    [LangKeys.all_customers]: "ਸਾਰੇ ਗਾਹਕ",
    [LangKeys.no_customers_found]: "ਕੋਈ ਗਾਹਕ ਨਹੀਂ ਮਿਲਿਆ",
    [LangKeys.no_suppliers_found]: "ਕੋਈ ਸਪਲਾਇਰ ਨਹੀਂ ਮਿਲਿਆ",
    [LangKeys.no_parties_found]: "ਕੋਈ ਵੀ ਪਾਰਟੀਆਂ ਨਹੀਂ ਮਿਲੀਆਂ",

    [LangKeys.just_now]: "ਹੁਣੇ ਹੁਣੇ",
    [LangKeys.min_ago]: "{value} ਮਿੰਟ ਪਹਿਲਾਂ",
    [LangKeys.hr_ago]: "{value} ਘੰਟੇ ਪਹਿਲਾਂ",
    [LangKeys.day_ago]: "{value} ਦਿਨ ਪਹਿਲਾਂ",
    [LangKeys.month_ago]: "{value} ਮਹੀਨੇ ਪਹਿਲਾਂ",
    [LangKeys.year_ago]: "{value} ਸਾਲ ਪਹਿਲਾਂ",

    [LangKeys.settled]: "ਹਿਸਾਬ ਬਰਾਬਰ",
    [LangKeys.advance]: "ਜਮਾ ਰਕਮ",
    [LangKeys.due]: "ਉਧਾਰ",
    [LangKeys.no_transactions]: "ਕੋਈ ਲੈਣ-ਦੇਣ ਨਹੀਂ",
    [LangKeys.no_entries_yet]: "ਹਾਲੇ ਤੱਕ ਕੋਈ ਐਂਟਰੀ ਨਹੀਂ",
    [LangKeys.new_label]: "ਨਵਾਂ",

    /* ================= DASHBOARD / HOME SCREEN ================= */
    [LangKeys.khata]: "ਖਾਤਾ",
    [LangKeys.you_will_get]: "ਤੁਹਾਨੂੰ ਮਿਲਣਗੇ",
    [LangKeys.you_will_give]: "ਤੁਸੀਂ ਦੇਵੋਗੇ",
    [LangKeys.search_khata_entry]: "ਖਾਤਾ ਐਂਟਰੀ ਲੱਭੋ",
    [LangKeys.recent_entries]: "ਹਾਲੀਆ ਐਂਟਰੀਆਂ",
    [LangKeys.unknown_party]: "ਅਣਜਾਣ ਪਾਰਟੀ",
    [LangKeys.unknown_customer]: "ਅਣਜਾਣ ਗਾਹਕ",
    [LangKeys.unknown]: "ਅਣਜਾਣ",

    // CUSTOMER LEDGER
    [LangKeys.ledger]: "ਖਾਤਾ-ਬਹੀ",
    [LangKeys.report]: "ਰਿਪੋਰਟ",
    [LangKeys.reminder]: "ਯਾਦ-ਦਹਾਨੀ",
    [LangKeys.sms]: "ਐਸਐਮਐਸ",
    [LangKeys.whatsapp]: "ਵਟਸਐਪ",
    [LangKeys.outstanding_balance]: "ਬਕਾਇਆ ਰਕਮ",
    [LangKeys.total_balance]: "ਕੁੱਲ ਬਕਾਇਆ",
    [LangKeys.you_got]: "ਤੁਹਾਨੂੰ ਮਿਲੇ",
    [LangKeys.you_gave]: "ਤੁਸੀਂ ਦਿੱਤੇ",
    [LangKeys.entries]: "ਐਂਟਰੀਆਂ",
    [LangKeys.no_entries_found]: "ਕੋਈ ਐਂਟਰੀ ਨਹੀਂ ਮਿਲੀ",
    [LangKeys.i_got]: "ਮੈਨੂੰ ਮਿਲੇ",
    [LangKeys.i_gave]: "ਮੈਂ ਦਿੱਤੇ",
    [LangKeys.you_got_caps]: "ਤੁਹਾਨੂੰ ਮਿਲੇ",
    [LangKeys.you_gave_caps]: "ਤੁਸੀਂ ਦਿੱਤੇ",
    [LangKeys.wa_dear]: "ਪਿਆਰੇ",
    [LangKeys.wa_account_update]: "ਮੋਕਸ਼ਪਾਲ ਖਾਤਾ ਤੋਂ ਤੁਹਾਡੇ ਖਾਤੇ ਦਾ ਅੱਪਡੇਟ ਇੱਥੇ ਹੈ।",
    [LangKeys.total_due]: "ਕੁੱਲ ਬਾਕੀ ਰਕਮ",
    [LangKeys.view_full_account]: "ਪੂਰਾ ਖਾਤਾ ਸਟੇਟਮੈਂਟ ਦੇਖੋ",
    [LangKeys.failed_to_load_data]: "ਡੇਟਾ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
    [LangKeys.could_not_open_whatsapp]: "WhatsApp ਨਹੀਂ ਖੋਲ੍ਹਿਆ ਜਾ ਸਕਿਆ।",
    [LangKeys.could_not_open_sms]: "SMS ਐਪ ਨਹੀਂ ਖੋਲ੍ਹਿਆ ਜਾ ਸਕਿਆ।",
    [LangKeys.total_purchase]: "ਕੁੱਲ ਖਰੀਦ",
    [LangKeys.total_received]: "ਕੁੱਲ ਪ੍ਰਾਪਤ",

    [LangKeys.entry_success]: "ਐਂਟਰੀ ਸਫਲ ਹੋਈ",
    [LangKeys.transaction_success]: "ਲੈਣ-ਦੇਣ ਸਫਲ ਹੋਇਆ",
    [LangKeys.done]: "ਮੁਕੰਮਲ ਹੋਇਆ",

    // ENTRY
    [LangKeys.entry_details]: "ਐਂਟਰੀ ਵੇਰਵੇ",
    [LangKeys.running_balance]: "ਚਲਦਾ ਬਕਾਇਆ",
    [LangKeys.share]: "ਸਾਂਝਾ ਕਰੋ",
    [LangKeys.network_error]: "ਨੈੱਟਵਰਕ ਤਰੁੱਟੀ",
    [LangKeys.copy_link]: "ਲਿੰਕ ਕਾਪੀ ਕਰੋ",
    [LangKeys.delete_entry]: "ਐਂਟਰੀ ਮਿਟਾਓ",
    [LangKeys.delete_entry_confirm]: "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ ਤੇ ਇਸ ਐਂਟਰੀ ਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    [LangKeys.delete_entry_warning]: "ਇਹ ਕਾਰਵਾਈ ਵਾਪਸ ਨਹੀਂ ਲਈ ਜਾ ਸਕਦੀ।",
    [LangKeys.edit_entry]: "ਐਂਟਰੀ ਸੰਪਾਦਿਤ ਕਰੋ",
    [LangKeys.invalid_entry]: "ਅਵੈਧ ਐਂਟਰੀ",
    [LangKeys.entry_not_found]: "ਐਂਟਰੀ ਨਹੀਂ ਮਿਲੀ",
    [LangKeys.invalid_entry_type]: "ਅਵੈਧ ਐਂਟਰੀ ਕਿਸਮ",
    [LangKeys.invalid_amount]: "ਅਵੈਧ ਰਕਮ",
    [LangKeys.invalid_date]: "ਅਵੈਧ ਮਿਤੀ",
    [LangKeys.photo_size_error]: "ਫੋਟੋ ਦਾ ਆਕਾਰ 1MB ਤੋਂ ਘੱਟ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
    [LangKeys.invalid_image_format]: "ਇਹ ਫੋਟੋ ਫਾਰਮੈਟ ਸਪੋਰਟ ਨਹੀਂ ਕਰਦਾ। ਕਿਰਪਾ ਕਰਕੇ JPG, PNG ਜਾਂ WEBP ਫੋਟੋ ਚੁਣੋ।",
    [LangKeys.photo_upload_failed]: "ਫੋਟੋ ਅੱਪਲੋਡ ਅਸਫਲ",
    [LangKeys.update_failed]: "ਅੱਪਡੇਟ ਅਸਫਲ",
    [LangKeys.amount]: "ਰਕਮ",
    [LangKeys.photo_max]: "ਫੋਟੋ (ਵੱਧ ਤੋਂ ਵੱਧ 1MB)",
    [LangKeys.change_photo]: "ਫੋਟੋ ਬਦਲੋ",
    [LangKeys.add_entry_title]: "ਐਂਟਰੀ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.save_entry]: "ਐਂਟਰੀ ਸੇਵ ਕਰੋ",
    [LangKeys.photo]: "ਫੋਟੋ",
    [LangKeys.amount_hint]: "₹ 0",
    [LangKeys.note_hint]: "ਵਿਕਲਪਿਕ ਨੋਟ",
    [LangKeys.add_photo_label]: "📷 ਫੋਟੋ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.failed_to_add_entry]: "ਐਂਟਰੀ ਸ਼ਾਮਲ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
    [LangKeys.image_too_large_4mb]: "ਚਿੱਤਰ ਬਹੁਤ ਵੱਡਾ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ 4MB ਤੋਂ ਘੱਟ ਦਾ ਚਿੱਤਰ ਚੁਣੋ।",
    [LangKeys.share_coming_soon]: "ਸਾਂਝਾ ਕਰਨ ਦੀ ਸੁਵਿਧਾ ਜਲਦੀ ਆ ਰਹੀ ਹੈ!",
    [LangKeys.image_load_failed]: "ਚਿੱਤਰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.select_date]: "ਮਿਤੀ ਚੁਣੋ",
    [LangKeys.photo_max_2mb]: "ਫੋਟੋ (ਵੱਧ ਤੋਂ ਵੱਧ 2MB)",
    [LangKeys.add_to_cashbook]: "ਕੈਸ਼ਬੁੱਕ ਵਿੱਚ ਵੀ ਸ਼ਾਮਲ ਕਰੋ",

    [LangKeys.owner_name]: "ਮਾਲਕ ਦਾ ਨਾਮ",
    [LangKeys.customer_ledger_statement]: "ਗਾਹਕ ਖਾਤਾ-ਬਹੀ ਸਟੇਟਮੈਂਟ",
    [LangKeys.phone]: "ਫ਼ੋਨ",
    [LangKeys.opening_balance]: "ਸ਼ੁਰੂਆਤੀ ਬਕਾਇਆ",
    [LangKeys.closing_balance]: "ਅੰਤਿਮ ਬਕਾਇਆ",
    [LangKeys.transaction_details]: "ਲੈਣ-ਦੇਣ ਦੇ ਵੇਰਵੇ",
    [LangKeys.particulars]: "ਵੇਰਵੇ",
    [LangKeys.credit_short]: "ਕ੍ਰੈ",
    [LangKeys.debit_short]: "ਡੈ",
    [LangKeys.generated_by]: "ਮੋਕਸ਼ਪਾਲ ਖਾਤਾ ਦੁਆਰਾ ਤਿਆਰ ਕੀਤਾ ਗਿਆ",
    [LangKeys.my_business]: "ਮੇਰਾ ਕਾਰੋਬਾਰ",
    [LangKeys.pdf_generation_error]: "PDF ਬਣਾਉਣ ਵਿੱਚ ਤਰੁੱਟੀ",
    [LangKeys.debit_minus]: "ਡੈਬਿਟ (-)",
    [LangKeys.credit_plus]: "ਕ੍ਰੈਡਿਟ (+)",
    [LangKeys.total_paid]: "ਕੁੱਲ ਅਦਾ ਕੀਤੀ ਰਕਮ",
    [LangKeys.received]: "ਪ੍ਰਾਪਤ ਹੋਇਆ",
    [LangKeys.paid]: "ਭੁਗਤਾਨ",
    [LangKeys.supplier_name]: "ਸਪਲਾਇਰ ਦਾ ਨਾਮ",
    [LangKeys.supplier_report]: "ਸਪਲਾਇਰ ਰਿਪੋਰਟ",
    [LangKeys.supplier_ledger_statement]: "ਸਪਲਾਇਰ ਲੈਜਰ ਸਟੇਟਮੈਂਟ",
    [LangKeys.data_not_available_for_pdf]: "PDF ਲਈ ਡਾਟਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",

    // ACCOUNT
    [LangKeys.account]: "ਖਾਤਾ",
    [LangKeys.add_business]: "ਕਾਰੋਬਾਰੀ ਵੇਰਵੇ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.add_owner]: "ਮਾਲਕ ਦੇ ਵੇਰਵੇ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.business]: "ਕਾਰੋਬਾਰ",
    [LangKeys.staff]: "ਸਟਾਫ",
    [LangKeys.items]: "ਵਸਤੂਆਂ",
    [LangKeys.bills]: "ਬਿੱਲ",
    [LangKeys.dairy]: "ਡੇਅਰੀ",
    [LangKeys.cashbook]: "ਕੈਸ਼ਬੁੱਕ",
    [LangKeys.help_support]: "ਮਦਦ ਅਤੇ ਸਹਾਇਤਾ",
    [LangKeys.about_app]: "ਸਾਡੇ ਬਾਰੇ",
    [LangKeys.invite_friends]: "ਦੋਸਤਾਂ ਨੂੰ ਸੱਦਾ ਦਿਓ",
    [LangKeys.privacy_policy]: "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
    [LangKeys.disclaimer]: "ਬੇਦਾਅਵਾ",
    [LangKeys.share_subject]: "📒 ਮੋਕਸਪਾਲ ਖਾਤਾ ਐਪ",
    [LangKeys.share_message]: "👉 ਉਧਾਰ-ਲੇਣਦੇਣ ਅਤੇ ਹਿਸਾਬ ਰੱਖਣ ਲਈ ਮੈਂ Moxpal Khata ਐਪ ਵਰਤ ਰਿਹਾ ਹਾਂ। ਇਹ ਬਹੁਤ ਆਸਾਨ ਅਤੇ ਭਰੋਸੇਯੋਗ ਐਪ ਹੈ। 📲 ਤੁਸੀਂ ਵੀ ਹੁਣੇ ਡਾਊਨਲੋਡ ਕਰੋ ਅਤੇ ਆਪਣੇ ਖਾਤੇ ਆਸਾਨੀ ਨਾਲ ਮੈਨੇਜ ਕਰੋ: https://khata.moxpal.com/app",

    // STAFF
    [LangKeys.staff_details]: "ਸਟਾਫ ਵੇਰਵੇ",
    [LangKeys.staff_question]: "ਸਟਾਫ ਕੀ ਹੈ?",
    [LangKeys.add_staff]: "ਸਟਾਫ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.staff_name]: "ਸਟਾਫ ਦਾ ਨਾਮ",
    [LangKeys.permissions]: "ਇਜਾਜ਼ਤਾਂ",
    [LangKeys.stop_staff]: "ਸਟਾਫ ਨੂੰ ਰੋਕੋ",
    [LangKeys.stop_staff_desc]: "ਇਹ ਸਟਾਫ ਤੁਹਾਡੇ ਕਾਰੋਬਾਰੀ ਡੇਟਾ ਤੱਕ ਪਹੁੰਚ ਨਹੀਂ ਕਰ ਸਕੇਗਾ।",
    [LangKeys.delete_staff]: "ਸਟਾਫ ਨੂੰ ਮਿਟਾਓ",
    [LangKeys.delete_staff_desc]: "ਇਹ ਸਟਾਫ ਸਥਾਈ ਤੌਰ ਤੇ ਮਿਟਾ ਦਿੱਤਾ ਜਾਵੇਗਾ।",
    [LangKeys.add_staff_to_manage]: "ਮੈਨੇਜ ਕਰਨ ਲਈ ਸਟਾਫ ਜੋੜੋ",

    // NAVBAR
    [LangKeys.home]: "ਹੋਮ",
    [LangKeys.more]: "ਹੋਰ",

    // ADD PARTY
    [LangKeys.add_party]: "ਪਾਰਟੀ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.address_optional]: "ਪਤਾ (ਵਿਕਲਪਿਕ)",
    [LangKeys.gst_optional]: "GSTIN (ਵਿਕਲਪਿਕ)",
    [LangKeys.add_supplier]: "ਸਪਲਾਇਰ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.name_required]: "ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    [LangKeys.edit]: "ਸੰਪਾਦਿਤ ਕਰੋ",

    // BOOK PROFILE
    [LangKeys.book_profile]: "ਖਾਤਾ ਪ੍ਰੋਫਾਈਲ ਬਣਾਓ",
    [LangKeys.personal_info]: "ਨਿੱਜੀ ਜਾਣਕਾਰੀ",
    [LangKeys.business_info]: "ਕਾਰੋਬਾਰੀ ਜਾਣਕਾਰੀ",
    [LangKeys.financial_info]: "ਵਿੱਤੀ ਜਾਣਕਾਰੀ",
    [LangKeys.staff_info]: "ਸਟਾਫ ਜਾਣਕਾਰੀ",
    [LangKeys.name]: "ਨਾਮ",
    [LangKeys.add_name]: "ਨਾਮ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.registered_number]: "ਰਜਿਸਟਰਡ ਮੋਬਾਈਲ ਨੰਬਰ",
    [LangKeys.add_mobile]: "ਮੋਬਾਈਲ ਨੰਬਰ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.business_name]: "ਕਾਰੋਬਾਰ ਦਾ ਨਾਮ",
    [LangKeys.business_address]: "ਕਾਰੋਬਾਰ ਦਾ ਪਤਾ",
    [LangKeys.add_address]: "ਪਤਾ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.gstin]: "GSTIN",
    [LangKeys.bank_account]: "ਬੈਂਕ ਖਾਤਾ",
    [LangKeys.add_details]: "ਵੇਰਵੇ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.details]: "ਵੇਰਵੇ",
    [LangKeys.add_photo]: "ਫੋਟੋ ਜੋੜੋ",
    [LangKeys.profile_strength]: "ਪ੍ਰੋਫਾਈਲ ਦੀ ਮਜ਼ਬੂਤੀ",
    [LangKeys.customer_profile]: "ਗਾਹਕ ਪ੍ਰੋਫਾਈਲ",
    [LangKeys.supplier_profile]: "ਸਪਲਾਇਰ ਪ੍ਰੋਫਾਈਲ",
    [LangKeys.address]: "ਪਤਾ",
    [LangKeys.type]: "ਕਿਸਮ",
    [LangKeys.customer]: "ਗਾਹਕ",
    [LangKeys.supplier]: "ਸਪਲਾਇਰ",
    [LangKeys.delete_customer]: "ਗਾਹਕ ਹਟਾਓ",
    [LangKeys.delete_supplier]: "ਸਪਲਾਇਰ ਹਟਾਓ",
    [LangKeys.delete_customer_desc]: "ਕੀ ਤੁਸੀਂ ਇਸ ਗਾਹਕ ਨੂੰ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ? ਇਸ ਨਾਲ ਸੰਬੰਧਿਤ ਸਾਰਾ ਡਾਟਾ ਮਿਟਾ ਦਿੱਤਾ ਜਾਵੇਗਾ।",
    [LangKeys.delete_supplier_desc]: "ਕੀ ਤੁਸੀਂ ਇਸ ਸਪਲਾਇਰ ਨੂੰ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ? ਇਸ ਨਾਲ ਸੰਬੰਧਿਤ ਸਾਰਾ ਡਾਟਾ ਮਿਟਾ ਦਿੱਤਾ ਜਾਵੇਗਾ।",
    [LangKeys.add_gstin]: "GSTIN ਜੋੜੋ",

    /* ================= SMS SETTINGS ================= */
    [LangKeys.sms_settings]: "SMS ਸੈਟਿੰਗਜ਼",
    [LangKeys.sms_settings_desc]: "ਇਸ ਗਾਹਕ ਲਈ ਮੈਸੇਜ ਸੈਟਿੰਗਜ਼ ਮੈਨੇਜ ਕਰੋ",
    [LangKeys.edit_customer_details]: "ਗਾਹਕ ਵੇਰਵੇ ਸੋਧੋ",
    [LangKeys.edit_customer_details_desc]: "ਤੁਸੀਂ ਇੱਥੇ ਨਾਮ, ਮੋਬਾਈਲ, ਪਤਾ ਅਤੇ GST ਜਾਣਕਾਰੀ ਬਦਲ ਸਕਦੇ ਹੋ।",

    // PROFILE STRENGTH
    [LangKeys.weak]: "ਕਮਜ਼ੋਰ",
    [LangKeys.average]: "ਔਸਤ",
    [LangKeys.good]: "ਚੰਗਾ",
    [LangKeys.strong]: "ਮਜ਼ਬੂਤ",

    // STAFF & PERMISSIONS
    [LangKeys.save_staff]: "ਸਟਾਫ ਸੇਵ ਕਰੋ",
    [LangKeys.update_staff]: "ਸਟਾਫ ਅੱਪਡੇਟ ਕਰੋ",
    [LangKeys.cancel]: "ਰੱਦ ਕਰੋ",
    [LangKeys.no_staff_found]: "ਕੋਈ ਸਟਾਫ ਨਹੀਂ ਮਿਲਿਆ",
    [LangKeys.active]: "ਸਰਗਰਮ",
    [LangKeys.stopped]: "ਰੋਕਿਆ ਗਿਆ",
    [LangKeys.start]: "ਸ਼ੁਰੂ ਕਰੋ",
    [LangKeys.stop]: "ਰੋਕੋ",
    [LangKeys.view]: "ਦੇਖੋ",
    [LangKeys.add]: "ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.delete]: "ਮਿਟਾਓ",
    [LangKeys.mobile_number]: "ਮੋਬਾਈਲ ਨੰਬਰ",
    [LangKeys.add_staff_title]: "ਸਟਾਫ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.edit_staff_title]: "ਸਟਾਫ ਸੰਪਾਦਿਤ ਕਰੋ",
    [LangKeys.staff_deleted_success]: "ਸਟਾਫ ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾ ਦਿੱਤਾ ਗਿਆ",
    [LangKeys.yes]: "ਹਾਂ",
    [LangKeys.no]: "ਨਹੀਂ",
    [LangKeys.khatabook_deleted_success]: "ਖਾਤਾ-ਬੁੱਕ ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾ ਦਿੱਤੀ ਗਈ",
    [LangKeys.something_went_wrong]: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ",
    [LangKeys.business_logo]: "ਕਾਰੋਬਾਰ ਦਾ ਲੋਗੋ",
    [LangKeys.choose_photo]: "ਫੋਟੋ ਚੁਣੋ",
    [LangKeys.save_logo]: "ਲੋਗੋ ਸੇਵ ਕਰੋ",
    [LangKeys.upload_error]: "ਅੱਪਲੋਡ ਤਰੁੱਟੀ",
    [LangKeys.upload_type_err]: "ਅੱਪਲੋਡ ਕਿਸਮ ਤਰੁੱਟੀ",
    [LangKeys.enter_name]: "ਨਾਮ ਦਰਜ ਕਰੋ",
    [LangKeys.enter_mobile]: "ਮੋਬਾਈਲ ਦਰਜ ਕਰੋ",
    [LangKeys.enter_business]: "ਕਾਰੋਬਾਰ ਦਰਜ ਕਰੋ",
    [LangKeys.enter_address]: "ਪਤਾ ਦਰਜ ਕਰੋ",
    [LangKeys.gstin_details]: "GSTIN ਵੇਰਵੇ",
    [LangKeys.gstin_number]: "GSTIN ਨੰਬਰ",
    [LangKeys.enter_gstin]: "GSTIN ਦਰਜ ਕਰੋ",
    [LangKeys.gstin_note]: "ਤੁਹਾਡਾ GSTIN ਤੁਹਾਡੇ ਕਾਰੋਬਾਰ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਅਤੇ ਇਨਵੌਇਸ ਬਣਾਉਣ ਲਈ ਵਰਤਿਆ ਜਾਂਦਾ ਹੈ।",
    [LangKeys.save_gstin]: "GSTIN ਸੇਵ ਕਰੋ",
    [LangKeys.bank_details]: "ਬੈਂਕ ਵੇਰਵੇ",
    [LangKeys.bank_name]: "ਬੈਂਕ ਦਾ ਨਾਮ",
    [LangKeys.enter_bank_name]: "ਬੈਂਕ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    [LangKeys.account_number]: "ਖਾਤਾ ਨੰਬਰ",
    [LangKeys.enter_account_no]: "ਖਾਤਾ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    [LangKeys.ifsc_code]: "IFSC ਕੋਡ",
    [LangKeys.enter_ifsc]: "IFSC ਕੋਡ ਦਰਜ ਕਰੋ",
    [LangKeys.bank_note]: "ਤੁਹਾਡਾ ਬੈਂਕ ਖਾਤਾ ਭੁਗਤਾਨ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਵਰਤਿਆ ਜਾਂਦਾ ਹੈ।",
    [LangKeys.save_bank_details]: "ਬੈਂਕ ਵੇਰਵੇ ਸੇਵ ਕਰੋ",
    [LangKeys.invalid_bank_details]: "ਅਵੈਧ ਬੈਂਕ ਵੇਰਵੇ",
    [LangKeys.confirm]: "ਪੁਸ਼ਟੀ ਕਰੋ",
    [LangKeys.invalid_gstin]: "ਅਵੈਧ GSTIN",
    [LangKeys.failed_to_save]: "ਸੇਵ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",

    // Cashbook
    [LangKeys.cash]: "ਨਕਦ",
    [LangKeys.online]: "ਆਨਲਾਈਨ",
    [LangKeys.total_balance_cashbook]: "ਕੁੱਲ ਬਾਕੀ",
    [LangKeys.today_balance]: "ਅੱਜ ਦਾ ਬਕਾਇਆ",
    [LangKeys.view_report]: "ਰਿਪੋਰਟ ਦੇਖੋ",
    [LangKeys.out_entry]: "ਬਾਹਰ",
    [LangKeys.in_entry]: "ਅੰਦਰ",
    [LangKeys.add_first_entry]: "ਆਪਣੀ ਪਹਿਲੀ ਐਂਟਰੀ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.attach_bill]: "ਬਿੱਲ ਨੱਥੀ ਕਰੋ",
    [LangKeys.enter_amount]: "ਰਕਮ ਦਰਜ ਕਰੋ",
    [LangKeys.empty_title]: "ਅਜੇ ਤੱਕ ਕੋਈ ਐਂਟਰੀ ਨਹੀਂ",
    [LangKeys.saving]: "ਸੇਵ ਹੋ ਰਿਹਾ ਹੈ...",
    [LangKeys.save_failed]: "ਸੇਵ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.server_error]: "ਸਰਵਰ ਤਰੁੱਟੀ",
    [LangKeys.ok]: "ਠੀਕ ਹੈ",
    [LangKeys.error]: "ਤਰੁੱਟੀ",
    [LangKeys.payment_mode]: "ਭੁਗਤਾਨ ਮੋਡ",
    [LangKeys.entry_saved_offline_and_will_be_synced_later]: "ਐਂਟਰੀ ਆਫਲਾਈਨ ਸੇਵ ਹੋ ਗਈ ਹੈ। ਇੰਟਰਨੈੱਟ ਆਉਣ 'ਤੇ ਸਿੰਕ ਹੋ ਜਾਵੇਗੀ",
    [LangKeys.entry_waiting_to_be_synced]: "ਐਂਟਰੀ ਆਫਲਾਈਨ ਸੇਵ ਹੈ, ਸਿੰਕ ਬਾਕੀ ਹੈ",
    [LangKeys.cash_in]: "ਜਮਾ ਕੀਤਾ ਗਿਆ",
    [LangKeys.cash_out]: "ਨਿਕਾਸੀ ਕੀਤੀ ਗਈ",
    [LangKeys.cashbook_status]: "ਕੈਸ਼ਬੁੱਕ ਸਟੇਟਸ",
    [LangKeys.real_time_cash_online]: "ਰੀਅਲ-ਟਾਈਮ ਕੈਸ਼ ਅਤੇ ਆਨਲਾਈਨ",

    // NEW Cashbook Specific keys
    [LangKeys.entry_is_backed_up]: "ਐਂਟਰੀ ਦਾ ਬੈਕਅੱਪ ਹੋ ਗਿਆ ਹੈ",
    [LangKeys.safe_and_secure]: "100% ਸੁਰੱਖਿਅਤ ਅਤੇ ਸੁਰੱਖਿਅਤ",
    [LangKeys.invalid_image_format_cashbook_popup]: "ਅਸਮਰਥਿਤ ਫਾਰਮੈਟ। ਕਿਰਪਾ ਕਰਕੇ JPG, PNG, ਜਾਂ WEBP ਦੀ ਵਰਤੋਂ ਕਰੋ।",
    [LangKeys.photo_size_error_cashbook_popup]: "ਫਾਈਲ ਬਹੁਤ ਵੱਡੀ ਹੈ (ਵੱਧ ਤੋਂ ਵੱਧ 4MB)",
    [LangKeys.selected_image]: "ਚੁਣਿਆ ਗਿਆ",

    // Cashbook Report Screen keys
    [LangKeys.cashbook_report_title]: "ਕੈਸ਼ਬੁੱਕ ਰਿਪੋਰਟ",
    [LangKeys.date_range]: "ਮਿਤੀ ਸੀਮਾ",
    [LangKeys.single_day]: "ਇੱਕ ਦਿਨ",
    [LangKeys.this_week]: "ਇਸ ਹਫ਼ਤੇ",
    [LangKeys.this_month]: "ਇਸ ਮਹੀਨੇ",
    [LangKeys.last_week]: "ਪਿਛਲੇ ਹਫ਼ਤੇ",
    [LangKeys.last_month]: "ਪਿਛਲੇ ਮਹੀਨੇ",
    [LangKeys.all]: "ਸਾਰੇ",
    [LangKeys.to]: "ਤੋਂ",
    [LangKeys.no_entries_found_period]: "ਇਸ ਮਿਆਦ ਵਿੱਚ ਕੋਈ ਐਂਟਰੀ ਨਹੀਂ ਮਿਲੀ।",
    [LangKeys.daily_balance_short]: "ਰੋਜ਼ਾਨਾ ਬਕਾਇਆ",
    [LangKeys.download_pdf]: "PDF ਡਾਊਨਲੋਡ ਕਰੋ",
    [LangKeys.pdf_download_not_implemented]: "PDF ਡਾਊਨਲੋਡ ਅਜੇ ਲਾਗੂ ਨਹੀਂ ਕੀਤਾ ਗਿਆ ਹੈ।",

    [LangKeys.daily_details]: "ਰੋਜ਼ਾਨਾ ਵੇਰਵੇ",
    [LangKeys.no_entries_on_this_day]: "ਇਸ ਦਿਨ ਕੋਈ ਐਂਟਰੀ ਨਹੀਂ ਹੈ",
    [LangKeys.add_entries_help]: "ਉਹਨਾਂ ਨੂੰ ਇੱਥੇ ਦੇਖਣ ਲਈ ਐਂਟਰੀਆਂ ਸ਼ਾਮਲ ਕਰੋ।",
    [LangKeys.add_entry_to]: "ਵਿੱਚ ਐਂਟਰੀ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.add_entry]: "ਐਂਟਰੀ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.could_not_load_report]: "ਰਿਪੋਰਟ ਲੋਡ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ।",

    // NEW Entry Details Screen specific keys
    [LangKeys.delete_failed]: "ਮਿਟਾਉਣ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.photo_max_4mb]: "ਫੋਟੋ (ਵੱਧ ਤੋਂ ਵੱਧ 4MB)",
    [LangKeys.entry_of_amount]: "ਦੀ ਐਂਟਰੀ ",

    // PDF CASHBOOK REPORT
    [LangKeys.daily_summary]: "ਰੋਜ਼ਾਨਾ ਸਾਰਾਂਸ਼",
    [LangKeys.total_in]: "ਕੁੱਲ ਅੰਦਰ",
    [LangKeys.total_out]: "ਕੁੱਲ ਬਾਹਰ",
    [LangKeys.no_data_available]: "ਕੋਈ ਡੇਟਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",

    // Months (for date formatting)
    [LangKeys.month_1]: "ਜਨ",
    [LangKeys.month_2]: "ਫਰ",
    [LangKeys.month_3]: "ਮਾਰਚ",
    [LangKeys.month_4]: "ਅਪ੍ਰੈਲ",
    [LangKeys.month_5]: "ਮਈ",
    [LangKeys.month_6]: "ਜੂਨ",
    [LangKeys.month_7]: "ਜੁਲਾਈ",
    [LangKeys.month_8]: "ਅਗ",
    [LangKeys.month_9]: "ਸਿਤੰ",
    [LangKeys.month_10]: "ਅਕਤੂ",
    [LangKeys.month_11]: "ਨਵੰ",
    [LangKeys.month_12]: "ਦਸੰ",

    // NEW Customer Supplier Add
    [LangKeys.add_customer]: "ਗਾਹਕ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.customer_already_exists]: "ਗਾਹਕ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ",
    [LangKeys.supplier_already_exists]: "ਸਪਲਾਇਰ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ",

    // ✅ NEW CASHBOOK EMPTY STATE
    [LangKeys.cashbook_welcome]: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ! ਆਓ ਅੱਜ ਦੀਆਂ ਐਂਟਰੀਆਂ ਕਰੀਏ",
    [LangKeys.add_first_entry_btn]: "ਆਪਣੀ ਪਹਿਲੀ ਐਂਟਰੀ ਸ਼ਾਮਲ ਕਰੋ",

    // ✅ NEW KEY FOR EMPTY STATE TEXT
    [LangKeys.add_customers_collect_faster]: "ਗਾਹਕਾਂ ਨੂੰ ਸ਼ਾਮਲ ਕਰੋ ਅਤੇ ਤੇਜ਼ੀ ਨਾਲ ਭੁਗਤਾਨ ਇਕੱਠੇ ਕਰੋ",

    // ✅ NEW KEYS FOR PERMISSIONS
    [LangKeys.permission_denied_title]: "ਇਜਾਜ਼ਤ ਰੱਦ ਕੀਤੀ ਗਈ",
    [LangKeys.permission_denied_content]: "ਫੋਟੋ ਐਕਸੈੱਸ ਸਦਾ ਲਈ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਐਪ ਸੈਟਿੰਗਜ਼ ਵਿੱਚ ਜਾ ਕੇ ਇਸਨੂੰ ਚਾਲੂ ਕਰੋ।",
    [LangKeys.permission_denied_settings_button]: "ਸੈਟਿੰਗਜ਼ ਖੋਲ੍ਹੋ",
    [LangKeys.permission_denied_cancel_button]: "ਰੱਦ ਕਰੋ",
    [LangKeys.permission_denied_generic_message]: "ਇਜਾਜ਼ਤ ਰੱਦ ਕੀਤੀ ਗਈ ਹੈ। ਫੋਟੋ ਚੁਣਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਫੋਟੋ ਐਕਸੈੱਸ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ।",

    // ✅ Contact Picker
    [LangKeys.permission_required]: "ਇਜਾਜ਼ਤ ਲੋੜੀਂਦੀ ਹੈ",
    [LangKeys.contacts_permission_message]: "Contact ਚੁਣਨ ਲਈ Contacts ਦੀ ਇਜਾਜ਼ਤ ਲੋੜੀਂਦੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਐਪ ਸੈਟਿੰਗਜ਼ ਵਿੱਚ ਇਸਨੂੰ ਚਾਲੂ ਕਰੋ।",
    [LangKeys.failed_to_open_contacts_picker]: "Contacts picker ਖੋਲ੍ਹਣ ਵਿੱਚ ਅਸਫਲ ਰਹੇ।",
    [LangKeys.permission_denied_to_read_contacts]: "Contacts ਪੜ੍ਹਨ ਦੀ ਇਜਾਜ਼ਤ ਰੱਦ ਕਰ ਦਿੱਤੀ ਗਈ ਹੈ।",

    // ================= ADD ITEM SCREEN =================
    [LangKeys.tax_exempted]: "ਕਰ ਮੁਕਤ",
    [LangKeys.no_gst]: "GST ਲਾਗੂ ਨਹੀਂ",
    [LangKeys.select_photo]: "ਫੋਟੋ ਚੁਣੋ",
    [LangKeys.gallery]: "ਗੈਲਰੀ",
    [LangKeys.camera]: "ਕੈਮਰਾ",
    [LangKeys.please_enter_item_name]: "ਕਿਰਪਾ ਕਰਕੇ ਆਈਟਮ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    [LangKeys.failed_to_upload_image]: "ਤਸਵੀਰ ਅਪਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀ",
    [LangKeys.item_updated_successfully]: "ਆਈਟਮ ਸਫਲਤਾਪੂਰਕ ਅੱਪਡੇਟ ਹੋ ਗਿਆ",
    [LangKeys.item_saved_successfully]: "ਆਈਟਮ ਸਫਲਤਾਪੂਰਕ ਸੇਵ ਹੋ ਗਿਆ",
    [LangKeys.failed_to_update_item]: "ਆਈਟਮ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    [LangKeys.failed_to_save_item]: "ਆਈਟਮ ਸੇਵ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    [LangKeys.confirm_deletion]: "ਡਿਲੀਟ ਦੀ ਪੁਸ਼ਟੀ",
    [LangKeys.are_you_sure_delete_item]: "ਕੀ ਤੁਸੀਂ ਇਸ ਆਈਟਮ ਨੂੰ ਡਿਲੀਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    [LangKeys.item_deleted_successfully]: "ਆਈਟਮ ਸਫਲਤਾਪੂਰਕ ਡਿਲੀਟ ਹੋ ਗਿਆ",
    [LangKeys.failed_to_delete_item]: "ਆਈਟਮ ਡਿਲੀਟ ਨਹੀਂ ਹੋ ਸਕਿਆ",
    [LangKeys.edit_item]: "ਆਈਟਮ ਐਡਿਟ ਕਰੋ",
    [LangKeys.edit_service]: "ਸੇਵਾ ਐਡਿਟ ਕਰੋ",
    [LangKeys.add_product]: "ਪ੍ਰੋਡਕਟ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.add_service]: "ਸੇਵਾ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.add_hsn_and_gst_details]: "HSN ਅਤੇ GST ਦੀ ਜਾਣਕਾਰੀ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.hsn]: "HSN",
    [LangKeys.enter_hsn]: "HSN ਦਰਜ ਕਰੋ",
    [LangKeys.gst_rate_percent]: "GST ਦਰ (%)",
    [LangKeys.enter_gst_rate]: "GST ਦਰ ਦਰਜ ਕਰੋ",
    [LangKeys.primary_unit]: "ਮੁੱਖ ਇਕਾਈ",
    [LangKeys.enter_item_name_here]: "ਇੱਥੇ ਆਈਟਮ ਦਾ ਨਾਮ ਲਿਖੋ",
    [LangKeys.sale_price]: "ਵੇਚਣ ਦੀ ਕੀਮਤ",
    [LangKeys.purchase_price]: "ਖਰੀਦ ਕੀਮਤ",
    [LangKeys.tax_included]: "ਕੀਮਤ ਵਿੱਚ ਕਰ ਸ਼ਾਮਲ ਹੈ",
    [LangKeys.opening_stock]: "ਸ਼ੁਰੂਆਤੀ ਸਟਾਕ",
    [LangKeys.low_stock_alert]: "ਘੱਟ ਸਟਾਕ ਅਲਰਟ",
    [LangKeys.as_of_date]: "ਤਾਰੀਖ ਤੱਕ",
    [LangKeys.enter_price]: "ਕੀਮਤ ਦਰਜ ਕਰੋ",
    [LangKeys.enter_count]: "ਮਾਤਰਾ ਦਰਜ ਕਰੋ",
    [LangKeys.save_item]: "ਆਈਟਮ ਸੇਵ ਕਰੋ",
    [LangKeys.delete_item]: "ਆਈਟਮ ਡਿਲੀਟ ਕਰੋ",
    [LangKeys.select_unit]: "ਇਕਾਈ ਚੁਣੋ",
    [LangKeys.search_unit]: "ਇਕਾਈ ਖੋਜੋ",
    [LangKeys.add_gst_rate]: "GST ਦਰ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.add_custom_tax]: "ਕਸਟਮ ਕਰ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.custom_tax]: "ਕਸਟਮ ਕਰ",
    [LangKeys.gst]: "GST",
    [LangKeys.cess]: "ਸੈੱਸ",
    [LangKeys.add_hsn_code]: "HSN ਕੋਡ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.hsn_code]: "HSN ਕੋਡ",
    [LangKeys.item_name]: "ਆਈਟਮ ਦਾ ਨਾਮ",
    [LangKeys.enter_hsn_code]: "HSN ਕੋਡ ਦਰਜ ਕਰੋ",
    [LangKeys.enter_item_name]: "ਆਈਟਮ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    [LangKeys.results]: "ਨਤੀਜੇ",
    [LangKeys.no_hsn_code_found]: "ਕੋਈ HSN ਕੋਡ ਨਹੀਂ ਮਿਲਿਆ",
    [LangKeys.use]: "ਵਰਤੋਂ ਕਰੋ",
    [LangKeys.as_hsn_code]: "HSN ਕੋਡ ਵਜੋਂ",
    [LangKeys.you_are_offline_please_connect_to_the_internet]: "ਤੁਸੀਂ ਆਫਲਾਈਨ ਹੋ। ਕਿਰਪਾ ਕਰਕੇ ਇੰਟਰਨੈੱਟ ਨਾਲ ਕਨੈਕਟ ਕਰੋ।",

    // ================= ITEMS SCREEN =================
    [LangKeys.products]: "ਪ੍ਰੋਡਕਟਸ",
    [LangKeys.services]: "ਸੇਵਾਵਾਂ",
    [LangKeys.add_product_caps]: "ਪ੍ਰੋਡਕਟ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.add_service_caps]: "ਸੇਵਾ ਸ਼ਾਮਲ ਕਰੋ",

    [LangKeys.add_items_and_get_started]: "ਆਪਣੀ ਇਨਵੈਂਟਰੀ ਮੈਨੇਜ ਕਰਨਾ ਸ਼ੁਰੂ ਕਰੋ",
    [LangKeys.manage_stock_feature]: "ਆਪਣੇ ਕਾਰੋਬਾਰ ਲਈ ਸਮਾਰਟ ਸਟਾਕ ਕੰਟਰੋਲ",
    [LangKeys.detailed_stock_history_feature]: "ਆਈਟਮ ਗਤੀਵਿਧੀਆਂ ਦਾ ਪੂਰਾ ਰਿਕਾਰਡ ਵੇਖੋ",
    [LangKeys.track_prices_and_profits_feature]: "ਕੀਮਤ ਅਤੇ ਨਫ਼ਾ ਮਾਰਜਿਨ ਨੂੰ ਆਸਾਨੀ ਨਾਲ ਮਾਨੀਟਰ ਕਰੋ",

    [LangKeys.search_items]: "ਆਈਟਮ ਖੋਜੋ",
    [LangKeys.my_items]: "ਮੇਰੇ ਆਈਟਮ",
    [LangKeys.item_added]: "ਆਈਟਮ ਸ਼ਾਮਲ ਹੋਇਆ",
    [LangKeys.low_stock]: "ਘੱਟ ਸਟਾਕ",
    [LangKeys.current_stock]: "ਮੌਜੂਦਾ ਸਟਾਕ",
    [LangKeys.stock_history]: "ਸਟਾਕ ਇਤਿਹਾਸ",
    [LangKeys.stock_in]: "ਸਟਾਕ ਇਨ",
    [LangKeys.stock_out]: "ਸਟਾਕ ਆਉਟ",
    [LangKeys.add_services_and_get_started]: "ਆਪਣੀਆਂ ਸੇਵਾਵਾਂ ਦਾ ਪ੍ਰਬੰਧਨ ਸ਼ੁਰੂ ਕਰੋ",
    [LangKeys.manage_services_feature]: "ਆਪਣੀਆਂ ਸਾਰੀਆਂ ਸੇਵਾ ਆਫਰਿੰਗਜ਼ ਨੂੰ ਸੁਧਾਰੋ ਅਤੇ ਮੈਨੇਜ ਕਰੋ",
    [LangKeys.save_sac_and_gst_feature]: "SAC ਕੋਡ ਅਤੇ GST ਵੇਰਵੇ ਆਸਾਨੀ ਨਾਲ ਸੰਭਾਲੋ",
    [LangKeys.track_sales_and_bills_feature]: "ਸੇਵਾ ਵਿਕਰੀ ਅਤੇ ਬਿਲਿੰਗ ਰਿਕਾਰਡ ਟ੍ਰੈਕ ਕਰੋ",

    [LangKeys.net_monthly_sales]: "ਕੁੱਲ ਮਹੀਨਾਵਾਰ ਵਿਕਰੀ",
    [LangKeys.rupees]: "ਰੁਪਏ",
    [LangKeys.search_services]: "ਸੇਵਾਵਾਂ ਖੋਜੋ",
    [LangKeys.my_services]: "ਮੇਰੀਆਂ ਸੇਵਾਵਾਂ",
    [LangKeys.service_price]: "ਸੇਵਾ ਦੀ ਕੀਮਤ",
    [LangKeys.unit]: "ਇਕਾਈ",
    [LangKeys.enter_purchased_quantity]: "ਖਰੀਦੀ ਗਈ ਮਾਤਰਾ ਦਰਜ ਕਰੋ",
    [LangKeys.enter_sold_quantity]: "ਵੇਚੀ ਗਈ ਮਾਤਰਾ ਦਰਜ ਕਰੋ",
    [LangKeys.quantity]: "ਮਾਤਰਾ",
    [LangKeys.add_notes_optional]: "ਨੋਟ ਸ਼ਾਮਲ ਕਰੋ (ਵਿਕਲਪਿਕ)",
    [LangKeys.stock_in_caps]: "ਸਟਾਕ ਇਨ",
    [LangKeys.stock_out_caps]: "ਸਟਾਕ ਆਉਟ",
    [LangKeys.total_stock]: "ਕੁੱਲ ਸਟਾਕ",
    [LangKeys.low_stock_items]: "ਘੱਟ ਸਟਾਕ ਵਾਲੇ ਆਈਟਮ",
    [LangKeys.all_items]: "ਸਾਰੇ ਆਈਟਮ",
    [LangKeys.failed_to_load_items]: "ਆਈਟਮ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",

    // Filter & Sort
    [LangKeys.filter_by_stock]: "ਸਟਾਕ ਅਨੁਸਾਰ ਫਿਲਟਰ ਕਰੋ",
    [LangKeys.sort_by_name_az]: "ਨਾਂ (A–Z) ਅਨੁਸਾਰ",
    [LangKeys.sort_by_name_za]: "ਨਾਂ (Z–A) ਅਨੁਸਾਰ",

    // ================= ADD SERVICE SCREEN =================
    [LangKeys.failed_to_process_image]: "ਤਸਵੀਰ ਪ੍ਰੋਸੈਸ ਨਹੀਂ ਹੋ ਸਕੀ",
    [LangKeys.could_not_pick_image]: "ਤਸਵੀਰ ਚੁਣੀ ਨਹੀਂ ਜਾ ਸਕੀ",
    [LangKeys.failed_to_upload_photo]: "ਫੋਟੋ ਅਪਲੋਡ ਨਹੀਂ ਹੋ ਸਕੀ",
    [LangKeys.failed_to_update_service]: "ਸੇਵਾ ਅੱਪਡੇਟ ਨਹੀਂ ਹੋ ਸਕੀ",
    [LangKeys.failed_to_add_service]: "ਸੇਵਾ ਸ਼ਾਮਲ ਨਹੀਂ ਹੋ ਸਕੀ",
    [LangKeys.are_you_sure_delete_service]: "ਕੀ ਤੁਸੀਂ ਇਸ ਸੇਵਾ ਨੂੰ ਡਿਲੀਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    [LangKeys.failed_to_delete_service]: "ਸੇਵਾ ਡਿਲੀਟ ਨਹੀਂ ਹੋ ਸਕੀ",
    [LangKeys.add_sac_and_gst_details]: "SAC ਅਤੇ GST ਦੀ ਜਾਣਕਾਰੀ ਸ਼ਾਮਲ ਕਰੋ",
    [LangKeys.sac_code]: "SAC ਕੋਡ",
    [LangKeys.enter_sac]: "SAC ਦਰਜ ਕਰੋ",
    [LangKeys.enter_service_name_here]: "ਇੱਥੇ ਸੇਵਾ ਦਾ ਨਾਮ ਲਿਖੋ",
    [LangKeys.please_enter_service_name]: "ਕਿਰਪਾ ਕਰਕੇ ਸੇਵਾ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    [LangKeys.tax_included_in_price]: "ਕੀਮਤ ਵਿੱਚ ਕਰ ਸ਼ਾਮਲ ਹੈ",
    [LangKeys.delete_service]: "ਸੇਵਾ ਡਿਲੀਟ ਕਰੋ",
    [LangKeys.save_changes]: "ਤਬਦੀਲੀਆਂ ਸੇਵ ਕਰੋ",

    // ================= ITEM DETAILS SCREEN =================
    [LangKeys.edit_product]: "ਪ੍ਰੋਡਕਟ ਐਡਿਟ ਕਰੋ",
    [LangKeys.stock_quantity]: "ਸਟਾਕ ਮਾਤਰਾ",
    [LangKeys.stock_value]: "ਸਟਾਕ ਕੀਮਤ",

    // ================= SERVICE DETAILS SCREEN =================
    [LangKeys.edit_service_caps]: "ਸੇਵਾ ਐਡਿਟ ਕਰੋ",
    [LangKeys.service_name]: "ਸੇਵਾ ਦਾ ਨਾਮ",
    [LangKeys.gst_percent]: "GST %",
    [LangKeys.no_sales_added_for_service]: "ਇਸ ਸੇਵਾ ਲਈ ਕੋਈ ਵਿਕਰੀ ਸ਼ਾਮਲ ਨਹੀਂ ਕੀਤੀ ਗਈ",
    [LangKeys.zero_percent]: "0%",

    [LangKeys.bills_add_sale]: "ਵਿਕਰੀ ਜੋੜੋ",
    [LangKeys.bills_search_sales_hint]: "ਵਿਕਰੀ ਖੋਜੋ",
    [LangKeys.bills_add_purchase]: "ਖਰੀਦ ਜੋੜੋ",
    [LangKeys.bills_search_purchases_hint]: "ਖਰੀਦ ਖੋਜੋ",
    [LangKeys.bills_add_expense]: "ਖਰਚ ਜੋੜੋ",
    [LangKeys.bills_search_expenses_hint]: "ਖਰਚ ਖੋਜੋ",
    [LangKeys.bills_start_creating_gst]: "GST ਬਿੱਲ ਬਣਾਉਣਾ ਸ਼ੁਰੂ ਕਰੋ",
    [LangKeys.bills_tab_sale]: "ਵਿਕਰੀ",
    [LangKeys.bills_tab_purchase]: "ਖਰੀਦ",
    [LangKeys.bills_tab_expense]: "ਖਰਚ",
    [LangKeys.bills_monthly_sales]: "ਮਹੀਨਾਵਾਰ ਵਿਕਰੀ",
    [LangKeys.bills_monthly_purchases]: "ਮਹੀਨਾਵਾਰ ਖਰੀਦ",
    [LangKeys.bills_view_reports]: "ਰਿਪੋਰਟ ਵੇਖੋ",
    [LangKeys.bills_todays_in]: "ਅੱਜ ਦੀ ਆਮਦ",
    [LangKeys.bills_todays_out]: "ਅੱਜ ਦਾ ਖਰਚ",
    [LangKeys.bills_cashbook]: "ਕੈਸ਼ਬੁੱਕ",
    [LangKeys.bills_empty_state_title]: "ਤੁਰੰਤ ਪ੍ਰੋਫੈਸ਼ਨਲ ਇਨਵੋਇਸ ਬਣਾਓ",
    [LangKeys.bills_empty_state_subtitle]: "ਲੇਜ਼ਰ, ਸਟਾਕ ਅਤੇ ਕੈਸ਼ਬੁੱਕ ਆਪੇ ਅੱਪਡੇਟ ਹੁੰਦੇ ਹਨ",
    [LangKeys.bills_empty_state_gst_support]: "GST ਅਤੇ Non-GST ਦੋਵੇਂ ਬਿਲਿੰਗ ਸਮਰਥਿਤ",
    [LangKeys.bills_see_sample_invoices]: "ਨਮੂਨਾ ਇਨਵੋਇਸ ਵੇਖੋ",
    [LangKeys.bills_no_matching_found]: "ਕੋਈ ਮਿਲਦਾ ਜੁਲਦਾ ਬਿੱਲ ਨਹੀਂ ਮਿਲਿਆ",
    [LangKeys.bills_payment_in]: "ਪ੍ਰਾਪਤ ਭੁਗਤਾਨ",
    [LangKeys.bills_status_fully_paid]: "ਪੂਰੀ ਤਰ੍ਹਾਂ ਅਦਾ",
    [LangKeys.bills_status_unpaid]: "ਬਕਾਇਆ",
    [LangKeys.bills_sale_bill]: "ਵਿਕਰੀ ਬਿੱਲ",
    [LangKeys.bills_purchase_bill]: "ਖਰੀਦ ਬਿੱਲ",
    [LangKeys.bills_expense_bill]: "ਖਰਚ",
    [LangKeys.bills_more_button]: "ਹੋਰ",
    [LangKeys.bills_added_to_ledger]: "✓ ਖਾਤੇ ਵਿੱਚ ਜੋੜਿਆ ਗਿਆ",

    // ================= FILTER & SORT =================
    [LangKeys.filter_and_sort]: "ਫਿਲਟਰ ਅਤੇ ਸੋਰਟ",
    [LangKeys.filter_by_status]: "ਸਥਿਤੀ ਅਨੁਸਾਰ ਫਿਲਟਰ ਕਰੋ",
    [LangKeys.filter_all_bills]: "ਸਾਰੇ ਬਿੱਲ",
    [LangKeys.filter_paid_bills]: "ਅਦਾ ਕੀਤੇ ਬਿੱਲ",
    [LangKeys.filter_unpaid_bills]: "ਬਾਕੀ ਬਿੱਲ",
    [LangKeys.sort_by]: "ਅਨੁਸਾਰ ਸੋਰਟ ਕਰੋ",
    [LangKeys.sort_latest_first]: "ਨਵੇਂ ਪਹਿਲਾਂ",
    [LangKeys.sort_oldest_first]: "ਪੁਰਾਣੇ ਪਹਿਲਾਂ",
    [LangKeys.sort_highest_amount]: "ਸਭ ਤੋਂ ਵੱਧ ਰਕਮ",
    [LangKeys.sort_lowest_amount]: "ਸਭ ਤੋਂ ਘੱਟ ਰਕਮ",
    [LangKeys.clear_filters]: "ਫਿਲਟਰ ਸਾਫ ਕਰੋ",
    [LangKeys.apply_filters]: "ਫਿਲਟਰ ਲਾਗੂ ਕਰੋ",

    /* ================= ADD BILL SCREEN ================= */
    [LangKeys.add_bill_sale]: "ਵਿਕਰੀ",
    [LangKeys.add_bill_purchase]: "ਖਰੀਦ",
    [LangKeys.add_bill_expense]: "ਖਰਚ",
    [LangKeys.add_bill_edit_sale_gst_bill]: "ਵਿਕਰੀ GST ਬਿੱਲ ਸੋਧੋ",
    [LangKeys.add_bill_sale_gst_bill]: "ਵਿਕਰੀ GST ਬਿੱਲ",
    [LangKeys.add_bill_edit_purchase_gst_bill]: "ਖਰੀਦ GST ਬਿੱਲ ਸੋਧੋ",
    [LangKeys.add_bill_purchase_gst_bill]: "ਖਰੀਦ GST ਬਿੱਲ",
    [LangKeys.add_bill_edit_expense]: "ਖਰਚ ਸੋਧੋ",
    [LangKeys.add_bill_expense_title]: "ਖਰਚ",
    [LangKeys.add_bill_edit_sale_bill]: "ਵਿਕਰੀ ਬਿੱਲ ਸੋਧੋ",
    [LangKeys.add_bill_sale_bill]: "ਵਿਕਰੀ ਬਿੱਲ",
    [LangKeys.add_bill_edit_purchase_bill]: "ਖਰੀਦ ਬਿੱਲ ਸੋਧੋ",
    [LangKeys.add_bill_purchase_bill]: "ਖਰੀਦ ਬਿੱਲ",
    [LangKeys.add_bill_sale_bill_no]: "ਵਿਕਰੀ ਬਿੱਲ ਨੰਬਰ",
    [LangKeys.add_bill_purchase_bill_no]: "ਖਰੀਦ ਬਿੱਲ ਨੰਬਰ",
    [LangKeys.add_bill_expense_no]: "ਖਰਚ ਨੰਬਰ",
    [LangKeys.add_bill_update_sale_bill]: "ਵਿਕਰੀ ਬਿੱਲ ਅੱਪਡੇਟ ਕਰੋ",
    [LangKeys.add_bill_generate_sale_bill]: "ਵਿਕਰੀ ਬਿੱਲ ਬਣਾਓ",
    [LangKeys.add_bill_update_purchase_bill]: "ਖਰੀਦ ਬਿੱਲ ਅੱਪਡੇਟ ਕਰੋ",
    [LangKeys.add_bill_generate_purchase_bill]: "ਖਰੀਦ ਬਿੱਲ ਬਣਾਓ",
    [LangKeys.add_bill_update_expense]: "ਖਰਚ ਅੱਪਡੇਟ ਕਰੋ",
    [LangKeys.add_bill_generate_expense]: "ਖਰਚ ਜੋੜੋ",
    [LangKeys.add_bill_select_customer_error]: "ਕਿਰਪਾ ਕਰਕੇ ਗਾਹਕ ਚੁਣੋ",
    [LangKeys.add_bill_add_item_error]: "ਘੱਟੋ-ਘੱਟ ਇੱਕ ਆਇਟਮ ਜੋੜੋ",
    [LangKeys.add_bill_updated_successfully]: "ਸਫਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਹੋਇਆ",
    [LangKeys.add_bill_saved_successfully]: "ਸਫਲਤਾਪੂਰਵਕ ਸੇਵ ਹੋਇਆ",
    [LangKeys.add_bill_failed_to_save]: "ਬਿੱਲ ਸੇਵ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.add_bill_error_occurred]: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ",
    [LangKeys.add_bill_bill_to]: "ਬਿੱਲ ਕਿਸਦੇ ਨਾਮ",
    [LangKeys.add_bill_search_parties]: "ਪਾਰਟੀਆਂ ਖੋਜੋ",
    [LangKeys.add_bill_add_new_party]: "ਨਵੀਂ ਪਾਰਟੀ ਜੋੜੋ",
    [LangKeys.add_bill_edit_party_details]: "ਪਾਰਟੀ ਵੇਰਵੇ ਸੋਧੋ",
    [LangKeys.add_bill_items]: "ਆਇਟਮਾਂ",
    [LangKeys.add_bill_enter_items_from_inventory]: "ਸਟਾਕ ਤੋਂ ਆਇਟਮ ਦਰਜ ਕਰੋ",
    [LangKeys.add_bill_add_new_item]: "ਨਵੀਂ ਆਇਟਮ ਜੋੜੋ",
    [LangKeys.add_bill_n_items]: "{n} ਆਇਟਮ",
    [LangKeys.add_bill_edit_or_add_items]: "ਆਇਟਮ ਸੋਧੋ ਜਾਂ ਜੋੜੋ",
    [LangKeys.add_bill_discount]: "ਛੂਟ",
    [LangKeys.add_bill_extra_discount]: "ਵਾਧੂ ਛੋਟ",
    [LangKeys.add_bill_item_subtotal]: "ਆਇਟਮ ਉਪ-ਕੁੱਲ",
    [LangKeys.add_bill_round_off]: "ਰਾਊਂਡ ਆਫ",
    [LangKeys.add_bill_bill_amount]: "ਬਿੱਲ ਰਕਮ",
    [LangKeys.add_bill_optional_fields]: "ਵਿਕਲਪਿਕ ਫੀਲਡ",
    [LangKeys.add_bill_printed_on_invoice]: "ਇਨਵੋਇਸ ‘ਤੇ ਛਪੇਗਾ",
    [LangKeys.add_bill_custom_fields]: "ਕਸਟਮ ਫੀਲਡ",
    [LangKeys.add_bill_party_address]: "ਪਾਰਟੀ ਦਾ ਪਤਾ",
    [LangKeys.add_bill_your_address]: "ਤੁਹਾਡਾ ਪਤਾ",
    [LangKeys.add_bill_terms_conditions]: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
    [LangKeys.add_bill_private_to_you]: "ਸਿਰਫ ਤੁਹਾਡੇ ਲਈ",
    [LangKeys.add_bill_add_notes_photos]: "ਨੋਟ ਜਾਂ ਫੋਟੋ ਜੋੜੋ",
    [LangKeys.add_bill_n_photos_added]: "{n} ਫੋਟੋ ਜੋੜੀਆਂ",
    [LangKeys.add_bill_balance_due]: "ਬਕਾਇਆ ਰਕਮ",
    [LangKeys.cgst]: "CGST",
    [LangKeys.sgst]: "SGST",
    [LangKeys.pending_bill_no]: "ਬਾਕੀ ਬਿੱਲ ਨੰ.",
    [LangKeys.add_bill_add_due_to_ledger]: "ਲੇਜਰ ਵਿੱਚ ਬਕਾਇਆ ਬੈਲੈਂਸ ਜੋੜੋ",
    [LangKeys.add_bill_select_supplier_error]: "ਕਿਰਪਾ ਕਰਕੇ ਸਪਲਾਇਰ ਚੁਣੋ",

    /* ================= BILL DETAILS SCREEN ================= */
    [LangKeys.bill_details_error_id_missing]: "ਬਿੱਲ ID ਮੌਜੂਦ ਨਹੀਂ",
    [LangKeys.bill_details_failed_to_load]: "ਬਿੱਲ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.bill_details_delete_confirmation_title]: "ਬਿੱਲ ਮਿਟਾਓ",
    [LangKeys.bill_details_delete_confirmation_content]: "ਕੀ ਤੁਸੀਂ ਇਹ ਬਿੱਲ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ? ਕਿਰਪਾ ਕਰਕੇ ਧਿਆਨ ਰੱਖੋ ਕਿ ਬਿੱਲ ਨਾਲ ਜੁੜੀ ਕੈਸ਼ਬੁੱਕ ਐਂਟਰੀ ਵੀ ਮਿਟਾ ਦਿੱਤੀ ਜਾਵੇਗੀ।",
    [LangKeys.bill_details_delete_button]: "ਮਿਟਾਓ",
    [LangKeys.bill_details_deleted_successfully]: "ਬਿੱਲ ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾਇਆ ਗਿਆ",
    [LangKeys.bill_details_failed_to_delete]: "ਬਿੱਲ ਮਿਟਾਉਣ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.bill_details_generating_pdf]: "PDF ਬਣਾਈ ਜਾ ਰਹੀ ਹੈ",
    [LangKeys.bill_details_share_text]: "ਇਹ ਤੁਹਾਡਾ ਬਿੱਲ ਹੈ",
    [LangKeys.bill_details_failed_to_share]: "ਬਿੱਲ ਸਾਂਝਾ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.bill_details_title]: "ਬਿੱਲ ਵੇਰਵੇ",
    [LangKeys.bill_details_could_not_load]: "ਬਿੱਲ ਵੇਰਵੇ ਲੋਡ ਨਹੀਂ ਹੋ ਸਕੇ",
    [LangKeys.bill_details_status]: "ਸਥਿਤੀ",
    [LangKeys.bill_details_status_pending]: "ਬਕਾਇਆ",
    [LangKeys.bill_details_no_items]: "ਕੋਈ ਆਇਟਮ ਨਹੀਂ ਜੋੜੀ",
    [LangKeys.bill_details_view_pdf]: "PDF ਵੇਖੋ",

    /* ================= EXPENSE DETAILS SCREEN ================= */
    [LangKeys.expense_number_prefix]: "ਖਰਚਾ #",
    [LangKeys.edit_expense]: "ਖਰਚਾ ਸੋਧੋ",
    [LangKeys.delete_expense]: "ਖਰਚਾ ਮਿਟਾਓ",
    [LangKeys.deleting_expense]: "ਮਿਟਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...",
    [LangKeys.expense_deleted_successfully]: "ਖਰਚਾ ਸਫਲਤਾਪੂਰਵਕ ਮਿਟਾ ਦਿੱਤਾ ਗਿਆ",
    [LangKeys.failed_to_delete_expense]: "ਖਰਚਾ ਮਿਟਾਉਣ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.edit_feature_coming_soon]: "ਸੋਧਣ ਦੀ ਸੁਵਿਧਾ ਜਲਦੀ ਆ ਰਹੀ ਹੈ!",
    [LangKeys.delete_expense_confirmation]: "ਕੀ ਤੁਸੀਂ ਯਕੀਨਨ ਇਹ ਖਰਚਾ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",

    /* ================= INVOICE PREVIEW SCREEN ================= */
    [LangKeys.invoice_preview_title]: "ਇਨਵੋਇਸ ਪ੍ਰੀਵਿਊ",
    [LangKeys.invoice_preview_generating]: "ਇਨਵੋਇਸ ਬਣਾਈ ਜਾ ਰਹੀ ਹੈ",
    [LangKeys.invoice_preview_failed]: "ਇਨਵੋਇਸ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.invoice_preview_preparing_print]: "ਪ੍ਰਿੰਟ ਲਈ ਤਿਆਰੀ",
    [LangKeys.invoice_preview_failed_print]: "ਪ੍ਰਿੰਟ ਅਸਫਲ",
    [LangKeys.invoice_preview_delete_title]: "ਇਨਵੋਇਸ ਮਿਟਾਓ",
    [LangKeys.invoice_preview_delete_content]: "ਕੀ ਤੁਸੀਂ ਇਹ ਇਨਵੌਇਸ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ? ਕਿਰਪਾ ਕਰਕੇ ਧਿਆਨ ਰੱਖੋ ਕਿ ਇਸ ਨਾਲ ਸੰਬੰਧਿਤ ਕੈਸ਼ਬੁੱਕ ਐਂਟਰੀ ਵੀ ਮਿਟਾ ਦਿੱਤੀ ਜਾਵੇਗੀ।",
    [LangKeys.invoice_preview_deleted_successfully]: "ਇਨਵੋਇਸ ਮਿਟਾਇਆ ਗਿਆ",
    [LangKeys.invoice_preview_failed_delete]: "ਇਨਵੋਇਸ ਮਿਟਾਉਣ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.invoice_preview_theme_premium]: "ਪ੍ਰੀਮੀਅਮ",
    [LangKeys.invoice_preview_theme_thermal]: "ਥਰਮਲ",
    [LangKeys.invoice_preview_theme_basic]: "ਬੇਸਿਕ",
    [LangKeys.invoice_preview_theme_new]: "ਨਵਾਂ",
    [LangKeys.invoice_preview_download]: "ਇਨਵੋਇਸ ਡਾਊਨਲੋਡ ਕਰੋ",
    [LangKeys.invoice_preview_share]: "ਇਨਵੋਇਸ ਸਾਂਝਾ ਕਰੋ",
    [LangKeys.invoice_preview_print]: "ਇਨਵੋਇਸ ਪ੍ਰਿੰਟ ਕਰੋ",
    [LangKeys.invoice_preview_create_new]: "ਨਵਾਂ ਬਣਾਓ",
    [LangKeys.invoice_preview_done]: "ਮੁਕੰਮਲ",

    /* ================= PAYMENT DETAILS SCREEN ================= */
    [LangKeys.payment_details_title_in]: "ਪ੍ਰਾਪਤ ਭੁਗਤਾਨ",
    [LangKeys.payment_details_title_out]: "ਦਿੱਤਾ ਭੁਗਤਾਨ",
    [LangKeys.payment_details_share_text]: "ਭੁਗਤਾਨ ਵੇਰਵੇ",
    [LangKeys.payment_details_failed_to_share]: "ਭੁਗਤਾਨ ਵੇਰਵੇ ਸਾਂਝੇ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.payment_details_adjusted_invoices]: "ਸਮਾਇਜਿਤ ਇਨਵੋਇਸ",

    /* ================= SAMPLE INVOICES SCREEN ================= */
    [LangKeys.sample_invoice_title]: "ਨਮੂਨਾ",
    [LangKeys.premium_invoice]: "ਪ੍ਰੀਮੀਅਮ ਇਨਵੋਇਸ",
    [LangKeys.thermal_invoice]: "ਥਰਮਲ ਇਨਵੋਇਸ",
    [LangKeys.basic_invoice]: "ਬੇਸਿਕ ਇਨਵੋਇਸ",
    [LangKeys.use_this_template]: "ਇਹ ਟੈਂਪਲੇਟ ਵਰਤੋ",

    /* ================= ITEM SELECT SHEET ================= */
    [LangKeys.item_select_not_enough_stock]: "ਪਰਯਾਪਤ ਸਟਾਕ ਨਹੀਂ ਹੈ। ਕੇਵਲ {availableStock} ਹੀ ਉਪਲਬਧ ਹੈ।",
    [LangKeys.item_select_no_items_found]: "ਕੋਈ ਆਇਟਮ ਨਹੀਂ ਮਿਲੀ",
    [LangKeys.item_select_item_discount]: "ਆਇਟਮ ਛੂਟ",
    [LangKeys.item_select_final_price]: "ਅੰਤਿਮ ਕੀਮਤ",
    [LangKeys.item_select_gst_rate]: "GST ਦਰ",
    [LangKeys.item_select_item_single]: "ਆਇਟਮ",
    [LangKeys.item_select_item_plural]: "ਆਇਟਮ",
    [LangKeys.item_select_continue]: "ਅੱਗੇ ਵਧੋ",
    [LangKeys.item_select_add_items_to_invoice]: "ਇਨਵੋਇਸ ਵਿੱਚ ਆਇਟਮ ਜੋੜੋ",
    [LangKeys.item_select_search_created_items]: "ਬਣਾਈਆਂ ਗਈਆਂ ਆਇਟਮਾਂ ਖੋਜੋ",
    [LangKeys.item_select_add_new]: "ਨਵੀਂ ਜੋੜੋ",

    /* ================= QUICK ADD ITEM DIALOG ================= */
    [LangKeys.add_more_details]: "ਹੋਰ ਵੇਰਵੇ ਜੋੜੋ (ਸਟਾਕ, ਖਰੀਦ ਕੀਮਤ ਆਦਿ)",
    [LangKeys.add_item_to_bill]: "ਬਿੱਲ ਵਿੱਚ ਆਇਟਮ ਜੋੜੋ",
    [LangKeys.please_enter_value]: "ਕਿਰਪਾ ਕਰਕੇ ਮੁੱਲ ਦਰਜ ਕਰੋ",
    [LangKeys.please_enter_valid_number]: "ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਨੰਬਰ ਦਰਜ ਕਰੋ",

    /* ================= CUSTOM FIELDS DIALOG ================= */
    [LangKeys.add_bill_custom_fields_subtitle]: "ਵੱਧ ਤੋਂ ਵੱਧ 5 ਕਸਟਮ ਫੀਲਡ ਜੋੜੋ (ਉਦਾਹਰਨ- ਸੀਰੀਅਲ ਨੰਬਰ, ਬੈਚ, IMEI ਆਦਿ)",
    [LangKeys.add_bill_add_new_custom_field]: "ਨਵਾਂ ਕਸਟਮ ਫੀਲਡ ਜੋੜੋ",
    [LangKeys.add_bill_max_custom_fields]: "ਤੁਸੀਂ ਵੱਧ ਤੋਂ ਵੱਧ 5 ਕਸਟਮ ਫੀਲਡ ਜੋੜ ਸਕਦੇ ਹੋ।",
    [LangKeys.add_bill_custom_field_name_hint]: "ਫੀਲਡ ਨਾਮ",
    [LangKeys.add_bill_custom_field_value_hint]: "ਮੁੱਲ",

    /* ================= EDIT PRICE DIALOG ================= */
    [LangKeys.edit_price_gst_details]: "({cgst}% CGST + {sgst}% SGST; {igst}% IGST)",
    [LangKeys.edit_price_enter_discount_hint]: "ਛੂਟ ਦਰਜ ਕਰੋ",
    [LangKeys.rupee]: "ਰੁਪਇਆ",
    [LangKeys.percentage]: "ਪ੍ਰਤੀਸ਼ਤ",
    [LangKeys.rate]: "ਦਰ",
    [LangKeys.tax]: "ਟੈਕਸ",

    /* ================= ADDRESS SCREEN ================= */
    [LangKeys.address_business_address_title]: "ਵਪਾਰ ਦਾ ਪਤਾ",
    [LangKeys.address_flat_building_number]: "ਫਲੈਟ / ਇਮਾਰਤ ਨੰਬਰ",
    [LangKeys.address_enter_flat_building_number]: "ਕਿਰਪਾ ਕਰਕੇ ਫਲੈਟ / ਇਮਾਰਤ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    [LangKeys.address_area_locality]: "ਇਲਾਕਾ / ਮੁਹੱਲਾ",
    [LangKeys.address_enter_area_locality]: "ਕਿਰਪਾ ਕਰਕੇ ਇਲਾਕਾ / ਮੁਹੱਲਾ ਦਰਜ ਕਰੋ",
    [LangKeys.address_city]: "ਸ਼ਹਿਰ",
    [LangKeys.address_enter_city]: "ਕਿਰਪਾ ਕਰਕੇ ਸ਼ਹਿਰ ਦਰਜ ਕਰੋ",
    [LangKeys.address_state]: "ਰਾਜ",
    [LangKeys.address_enter_state]: "ਕਿਰਪਾ ਕਰਕੇ ਰਾਜ ਦਰਜ ਕਰੋ",
    [LangKeys.address_pincode]: "ਪਿਨ ਕੋਡ",
    [LangKeys.address_enter_pincode]: "ਕਿਰਪਾ ਕਰਕੇ ਪਿਨ ਕੋਡ ਦਰਜ ਕਰੋ",
    [LangKeys.address_invalid_pincode]: "ਅਵੈਧ ਪਿਨ ਕੋਡ",

    [LangKeys.party_address_title]: "ਗਾਹਕ ਦਾ ਪਤਾ",
    [LangKeys.party_address_billing_address]: "ਬਿਲਿੰਗ ਪਤਾ",
    [LangKeys.party_address_shipping_same_as_billing]: "ਸ਼ਿਪਿੰਗ ਪਤਾ ਬਿਲਿੰਗ ਵਰਗਾ ਹੀ",

    /* ================= ADD NOTES AND PHOTOS DIALOG ================= */
    [LangKeys.add_notes_and_photos_title]: "ਨੋਟਸ ਅਤੇ ਫੋਟੋ ਜੋੜੋ",
    [LangKeys.add_notes_and_photos_subtitle]: "ਵਾਧੂ ਵੇਰਵੇ ਜਾਂ ਤਸਵੀਰਾਂ ਜੋੜੋ",
    [LangKeys.add_notes_and_photos_notes_hint]: "ਇੱਥੇ ਨੋਟਸ ਲਿਖੋ",
    [LangKeys.photos_access_permanently_denied]: "ਫੋਟੋ ਐਕਸੈਸ ਸਥਾਈ ਤੌਰ ‘ਤੇ ਰੱਦ ਕਰ ਦਿੱਤਾ ਗਿਆ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਐਪ ਸੈਟਿੰਗ ਵਿੱਚ ਜਾ ਕੇ ਇਸਨੂੰ ਚਾਲੂ ਕਰੋ।",
    [LangKeys.photos_access_denied]: "ਫੋਟੋ ਚੁਣਨ ਲਈ, ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਡਿਵਾਈਸ ਦੀ ਸੈਟਿੰਗ ਵਿੱਚ ਕੈਮਰਾ ਜਾਂ ਫੋਟੋ ਐਕਸੈਸ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ।",
    [LangKeys.open_settings]: "ਸੈਟਿੰਗ ਖੋਲ੍ਹੋ",

    /* ================= TERMS AND CONDITIONS DIALOG ================= */
    [LangKeys.terms_and_conditions_title]: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
    [LangKeys.terms_and_conditions_hint]: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਦਰਜ ਕਰੋ",

    // ================= KHATA TABS =================
    [LangKeys.customers]: "ਗਾਹਕ",
    [LangKeys.suppliers]: "ਸਪਲਾਇਰ",
    [LangKeys.search_supplier]: "ਸਪਲਾਇਰ ਖੋਜੋ",
    [LangKeys.add_first_customer]: "ਆਪਣਾ ਪਹਿਲਾ ਗਾਹਕ ਜੋੜੋ",
    [LangKeys.add_first_supplier]: "ਆਪਣਾ ਪਹਿਲਾ ਸਪਲਾਇਰ ਜੋੜੋ",
    [LangKeys.add_new_customer_prompt]: "ਹਾਲੇ ਤੱਕ ਕੋਈ ਗਾਹਕ ਨਹੀਂ ਜੋੜਿਆ ਗਿਆ। ਨਵਾਂ ਗਾਹਕ ਜੋੜਣ ਲਈ ਉੱਪਰ ਦਿੱਤੇ “+” ਬਟਨ ‘ਤੇ ਟੈਪ ਕਰੋ।",
    [LangKeys.add_new_suppliers_prompt]: "ਹਾਲੇ ਤੱਕ ਕੋਈ ਸਪਲਾਇਰ ਨਹੀਂ ਜੋੜਿਆ ਗਿਆ। ਨਵਾਂ ਸਪਲਾਇਰ ਜੋੜਣ ਲਈ ਉੱਪਰ ਦਿੱਤੇ “+” ਬਟਨ ‘ਤੇ ਟੈਪ ਕਰੋ।",

    // ================= CASHBOOK HELP DIALOG =================
    [LangKeys.cashbook_help_title]: "ਕੈਸ਼ਬੁੱਕ ਮਦਦ",
    [LangKeys.cashbook_help_in_title]: "ਕੈਸ਼ ਇਨ (ਜਮਾ)",
    [LangKeys.cashbook_help_in_desc]: "ਇੱਥੇ ਤੁਹਾਡੇ ਕਾਰੋਬਾਰ ਵਿੱਚ ਪ੍ਰਾਪਤ ਹੋਈਆਂ ਸਾਰੀਆਂ ਨਕਦ ਐਂਟਰੀਆਂ ਦਾ ਰਿਕਾਰਡ ਦਿਖਾਇਆ ਜਾਂਦਾ ਹੈ।",
    [LangKeys.cashbook_help_out_title]: "ਕੈਸ਼ ਆਉਟ (ਨਿਕਾਸ)",
    [LangKeys.cashbook_help_out_desc]: "ਇੱਥੇ ਤੁਹਾਡੇ ਕਾਰੋਬਾਰ ਤੋਂ ਖਰਚ ਕੀਤੀਆਂ ਸਾਰੀਆਂ ਨਕਦ ਐਂਟਰੀਆਂ ਦਾ ਰਿਕਾਰਡ ਦਿਖਾਇਆ ਜਾਂਦਾ ਹੈ।",
    [LangKeys.cashbook_help_total_balance_title]: "ਕੁੱਲ ਬਕਾਇਆ",
    [LangKeys.cashbook_help_total_balance_desc]: "ਇਹ ਤੁਹਾਡੇ ਕੈਸ਼ਬੁੱਕ ਦਾ ਮੌਜੂਦਾ ਕੁੱਲ ਬਕਾਇਆ ਦਿਖਾਉਂਦਾ ਹੈ।",
    [LangKeys.cashbook_help_today_balance_title]: "ਅੱਜ ਦਾ ਬਕਾਇਆ",
    [LangKeys.cashbook_help_today_balance_desc]: "ਇਹ ਸਿਰਫ਼ ਅੱਜ ਦੀਆਂ ਨਕਦ ਲੈਣ-ਦੇਣ ਦੇ ਆਧਾਰ 'ਤੇ ਬਕਾਇਆ ਦਿਖਾਉਂਦਾ ਹੈ।",
    [LangKeys.cashbook_help_report_title]: "ਕੈਸ਼ਬੁੱਕ ਰਿਪੋਰਟ",
    [LangKeys.cashbook_help_report_desc]: "ਇੱਥੋਂ ਤੁਸੀਂ ਕੈਸ਼ਬੁੱਕ ਰਿਪੋਰਟ ਵੇਖ ਅਤੇ ਡਾਊਨਲੋਡ ਕਰ ਸਕਦੇ ਹੋ।",

    // ✅ NEW KEYS FOR ADD EXPENSE SCREEN
    [LangKeys.expense_amount]: "ਖਰਚ ਦੀ ਰਕਮ",
    [LangKeys.select_category]: "ਸ਼੍ਰੇਣੀ ਚੁਣੋ",
    [LangKeys.select_expense_category]: "ਖਰਚ ਦੀ ਸ਼੍ਰੇਣੀ ਚੁਣੋ",
    [LangKeys.expense_items_warning]: "ਖਰਚ ਦੀਆਂ ਆਈਟਮਾਂ ਤੁਹਾਡੇ ਇਨਵੈਂਟਰੀ ਆਈਟਮਾਂ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਨਹੀਂ ਕਰਨਗੀਆਂ।",
    [LangKeys.add_expense_items_optional]: "ਖਰਚ ਦੀਆਂ ਆਈਟਮਾਂ ਸ਼ਾਮਲ ਕਰੋ (ਵਿਕਲਪਿਕ)",
    [LangKeys.expense_items_feature_coming_soon]: "ਖਰਚ ਆਈਟਮ ਫੀਚਰ ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ!",
    [LangKeys.notes_and_photos_optional]: "ਨੋਟਸ ਅਤੇ ਫੋਟੋਆਂ (ਵਿਕਲਪਿਕ)",
    [LangKeys.photos_added]: "ਫੋਟੋਆਂ ਸ਼ਾਮਲ ਕੀਤੀਆਂ ਗਈਆਂ",
    [LangKeys.save_expense_amount]: "ਖਰਚ ਸੇਵ ਕਰੋ",
    [LangKeys.update_expense_amount]: "ਖਰਚ ਅਪਡੇਟ ਕਰੋ",
    [LangKeys.expense_saved_successfully]: "ਖਰਚ ਸਫਲਤਾਪੂਰਵਕ ਸੇਵ ਹੋ ਗਿਆ",
    [LangKeys.expense_updated_successfully]: "ਖਰਚ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਹੋ ਗਿਆ",
    [LangKeys.failed_to_save_expense]: "ਖਰਚ ਸੇਵ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.enter_valid_amount]: "ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਰਕਮ ਦਰਜ ਕਰੋ।",
    [LangKeys.please_select_expense_category]: "ਕਿਰਪਾ ਕਰਕੇ ਖਰਚ ਦੀ ਸ਼੍ਰੇਣੀ ਚੁਣੋ।",
    [LangKeys.category]: "ਸ਼੍ਰੇਣੀ",

    // ===== EXPENSE CATEGORIES =====
    [LangKeys.cat_rent]: "ਕਿਰਾਇਆ",
    [LangKeys.cat_salaries]: "ਤਨਖਾਹ / ਮਜ਼ਦੂਰੀ",
    [LangKeys.cat_electricity]: "ਬਿਜਲੀ",
    [LangKeys.cat_water]: "ਪਾਣੀ ਦਾ ਬਿੱਲ",
    [LangKeys.cat_internet]: "ਟੈਲੀਫੋਨ / ਇੰਟਰਨੈੱਟ",
    [LangKeys.cat_office]: "ਦਫ਼ਤਰੀ ਖਰਚੇ",
    [LangKeys.cat_marketing]: "ਮਾਰਕੇਟਿੰਗ / ਵਿਗਿਆਪਨ",
    [LangKeys.cat_travel]: "ਯਾਤਰਾ",
    [LangKeys.cat_fuel]: "ਈੰਧਨ / ਪੈਟਰੋਲ",
    [LangKeys.cat_food]: "ਖਾਣਾ / ਨਾਸ਼ਤਾ",
    [LangKeys.cat_repairs]: "ਮੁਰੰਮਤ ਅਤੇ ਸੰਭਾਲ",
    [LangKeys.cat_election]: "ਚੋਣ ਖਰਚੇ",
    [LangKeys.cat_taxes]: "ਟੈਕਸ / GST",
    [LangKeys.cat_insurance]: "ਬੀਮਾ",
    [LangKeys.cat_cleaning]: "ਸਫਾਈ",
    [LangKeys.cat_delivery]: "ਡਿਲਿਵਰੀ / ਸ਼ਿਪਿੰਗ",
    [LangKeys.cat_software]: "ਸਾਫਟਵੇਅਰ / ਐਪਸ",
    [LangKeys.cat_furniture]: "ਫਰਨੀਚਰ",
    [LangKeys.cat_other]: "ਹੋਰ",

    // ================= EXPENSE EMPTY STATE =================
    [LangKeys.expense_empty_title]: "ਆਪਣੇ ਖਰਚੇ ਆਸਾਨੀ ਨਾਲ ਮੈਨੇਜ ਕਰੋ",
    [LangKeys.expense_empty_subtitle]: "ਆਪਣੇ ਕਾਰੋਬਾਰ ਦੇ ਸਾਰੇ ਖਰਚੇ ਇੱਕ ਹੀ ਥਾਂ ਟਰੈਕ ਕਰੋ।",
    [LangKeys.expense_empty_footer]: "ਸਾਰੇ ਖਰਚੇ ਆਪਣੇ ਆਪ ਕੈਸ਼ਬੁੱਕ ਵਿੱਚ ਜੋੜੇ ਜਾਂਦੇ ਹਨ।",

    // ================= BILL REPORT SCREEN =================
    [LangKeys.bill_report_title]: "ਬਿਲ ਰਿਪੋਰਟ",
    [LangKeys.report_for_period]: "ਇਸ ਅਵਧੀ ਲਈ ਰਿਪੋਰਟ",
    [LangKeys.select_date_range]: "ਤਾਰੀਖ ਦੀ ਰੇਂਜ ਚੁਣੋ",
    [LangKeys.total_sales]: "ਕੁੱਲ ਵਿਕਰੀ",
    [LangKeys.total_purchases]: "ਕੁੱਲ ਖਰੀਦ",
    [LangKeys.total_expenses]: "ਕੁੱਲ ਖਰਚੇ",
    [LangKeys.net_profit]: "ਸ਼ੁੱਧ ਨਫ਼ਾ",
    [LangKeys.net_loss]: "ਸ਼ੁੱਧ ਨੁਕਸਾਨ",
    [LangKeys.all_transactions]: "ਸਾਰੇ ਲੈਣ-ਦੇਣ",
    [LangKeys.no_transactions_found_period]: "ਇਸ ਅਵਧੀ ਵਿੱਚ ਕੋਈ ਲੈਣ-ਦੇਣ ਨਹੀਂ ਮਿਲਿਆ",
    [LangKeys.expense_fallback_category]: "ਹੋਰ ਖਰਚੇ",

    // ================= SALES REPORT SCREEN =================
    [LangKeys.sales_report]: "ਵਿਕਰੀ ਰਿਪੋਰਟ",
    [LangKeys.transactions]: "ਲੈਣ-ਦੇਣ",
    [LangKeys.net_sale]: "ਸ਼ੁੱਧ ਵਿਕਰੀ",
    [LangKeys.unpaid_balance]: "ਬਾਕੀ ਰਕਮ",
    [LangKeys.sales_report_share_text]: "ਇਹ ਤੁਹਾਡੀ ਵਿਕਰੀ ਰਿਪੋਰਟ ਦਾ ਸੰਖੇਪ ਹੈ।",

    // ================= PURCHASE REPORT SCREEN =================
    [LangKeys.purchase_report]: "ਖਰੀਦ ਰਿਪੋਰਟ",
    [LangKeys.net_purchase]: "ਸ਼ੁੱਧ ਖਰੀਦ",
    [LangKeys.purchase_report_share_text]: "ਇਹ ਤੁਹਾਡੀ ਖਰੀਦ ਰਿਪੋਰਟ ਦਾ ਸੰਖੇਪ ਹੈ।",

    // ================= KHATA FILTER & SORT =================
    [LangKeys.filter_by_balance]: "ਬਕਾਇਆ ਰਕਮ ਅਨੁਸਾਰ ਫਿਲਟਰ ਕਰੋ",
    [LangKeys.filter_all_parties]: "ਸਾਰੇ ਪਾਰਟੀਆਂ",

    // ================= LOGOUT =================
    [LangKeys.logout_confirm]: "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਲੌਗਆਉਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    [LangKeys.confirm_logout]: "ਲੌਗਆਉਟ",

    // ================= DEVICES =================
    [LangKeys.manage_devices]: "ਡਿਵਾਈਸ ਮੈਨੇਜ ਕਰੋ",
    [LangKeys.active_devices]: "ਸਕ੍ਰਿਯ ਡਿਵਾਈਸ",
    [LangKeys.logout_device]: "ਡਿਵਾਈਸ ਲੌਗਆਉਟ",
    [LangKeys.logout_device_confirm]: "ਕੀ ਤੁਸੀਂ ਇਸ ਡਿਵਾਈਸ ਨੂੰ ਲੌਗਆਉਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    [LangKeys.device_logged_out]: "ਡਿਵਾਈਸ ਸਫਲਤਾਪੂਰਵਕ ਲੌਗਆਉਟ ਹੋ ਗਿਆ",
    [LangKeys.no_active_devices]: "ਕੋਈ ਵੀ ਸਕ੍ਰਿਯ ਡਿਵਾਈਸ ਨਹੀਂ",
    [LangKeys.last_login]: "ਆਖਰੀ ਲੌਗਇਨ",
    [LangKeys.this_device]: "ਇਹ ਡਿਵਾਈਸ",
    [LangKeys.loading_devices]: "ਡਿਵਾਈਸ ਲੋਡ ਹੋ ਰਹੇ ਹਨ...",

    /* ================= SMS SETTINGS ================= */
    [LangKeys.send_whatsapp_messages]: "ਵਟਸਐਪ ਸੁਨੇਹੇ ਭੇਜਣ",
    [LangKeys.enabled]: "ਚਾਲੂ",
    [LangKeys.disabled]: "ਬੰਦ",
    [LangKeys.manage_whatsapp_settings]: "ਵਟਸਐਪ SMS ਸੈਟਿੰਗਜ਼ ਮੈਨੇਜ ਕਰੋ",
    [LangKeys.recharge_and_control]: "ਕ੍ਰੈਡਿਟ ਰੀਚਾਰਜ ਕਰੋ ਅਤੇ ਸੁਨੇਹੇ ਕੰਟਰੋਲ ਕਰੋ",

    [LangKeys.wa_message_failed]: "ਸੁਨੇਹਾ ਭੇਜਣ ਵਿੱਚ ਅਸਫਲ",
    [LangKeys.wa_no_credits]: "ਕ੍ਰੈਡਿਟ ਖਤਮ ਹੋ ਗਏ, ਸੁਨੇਹਾ ਨਹੀਂ ਭੇਜਿਆ ਗਿਆ",

    // DASHBOARD EMPTY STATE
    [LangKeys.pro_tip]: "ਪ੍ਰੋ ਟਿੱਪ",
    [LangKeys.dashboard_empty_tip]: "ਪੂਰੀ ਜਾਣਕਾਰੀ ਵੇਖਣ, ਸੋਧਣ ਜਾਂ ਗਾਹਕਾਂ ਨਾਲ ਸਾਂਝੀ ਕਰਨ ਲਈ ਖੱਬੇ ਪਾਸੇ ਕਿਸੇ ਵੀ ਐਂਟਰੀ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
    [LangKeys.select_entry]: "ਐਂਟਰੀ ਚੁਣੋ",
    [LangKeys.entry_details_appear]: "ਐਂਟਰੀ ਦੇ ਵੇਰਵੇ ਇੱਥੇ ਦਿਖਾਈ ਦੇਣਗੇ",

    // REPORTS DASHBOARD
    [LangKeys.business_reports]: "ਕਾਰੋਬਾਰੀ ਰਿਪੋਰਟਾਂ",
    [LangKeys.business_reports_desc]: "ਤੁਹਾਡੇ ਕਾਰੋਬਾਰ ਲਈ ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਜਾਣਕਾਰੀ",
    [LangKeys.ledger_cashbook_reports]: "ਖਾਤਾ ਅਤੇ ਕੈਸ਼ਬੁੱਕ ਰਿਪੋਰਟਾਂ",
    [LangKeys.billing_inventory_reports]: "ਬਿਲਿੰਗ ਅਤੇ ਇਨਵੈਂਟਰੀ ਰਿਪੋਰਟਾਂ",
    [LangKeys.customer_ledger_statement_report]: "ਗਾਹक ਖਾਤਾ ਰਿਪੋਰਟ",
    [LangKeys.customer_ledger_report_desc]: "ਸਾਰੇ ਗਾਹਕਾਂ ਲਈ ਵਿਸਤ੍ਰਿਤ ਖਾਤਾ ਅਤੇ ਲੈਣ-ਦੇਣ ਦਾ ਇਤਿਹਾਸ",
    [LangKeys.supplier_ledger_statement_report]: "ਸਪਲਾਇਰ ਖਾਤਾ ਰਿਪੋਰਟ",
    [LangKeys.supplier_ledger_report_desc]: "ਸਾਰੇ ਸਪਲਾਇਰਾਂ ਲਈ ਵਿਸਤ੍ਰਿਤ ਖਾਤਾ ਅਤੇ ਲੈਣ-ਦੇਣ ਦਾ ਇਤਿਹਾਸ",
    [LangKeys.cashbook_report_desc]: "ਨਕਦ ਅਤੇ ਆਨਲਾਈਨ ਲੈਣ-ਦੇਣ ਦਾ ਰੋਜ਼ਾਨਾ ਵੇਰਵਾ",
    [LangKeys.sales_report_desc]: "ਬਿੱਲ-ਵਾਰ ਵਿਕਰੀ ਸਾਰਾਂਸ਼, ਕੁੱਲ ਵਿਕਰੀ ਅਤੇ ਬਕਾਇਆ ਰਕਮ",
    [LangKeys.purchase_report_desc]: "ਬਿੱਲ-ਵਾਰ ਖਰੀਦ ਰਿਕਾਰਡ ਅਤੇ ਖਰੀਦ ਸਾਰਾਂਸ਼",
    [LangKeys.bills_summary_report]: "ਬਿੱਲ ਸਾਰਾਂਸ਼ ਰਿਪੋਰਟ",
    [LangKeys.bills_summary_report_desc]: "ਵਿਕਰੀ, ਖਰੀਦ ਅਤੇ ਮੁਨਾਫਾ-ਨੁਕਸਾਨ ਦਾ ਪੂਰਾ ਵਿਸ਼ਲੇਸ਼ਣ",
    [LangKeys.item_stock_sales_report]: "ਆਈਟਮ ਸਟਾਕ ਅਤੇ ਵਿਕਰੀ ਰਿਪੋਰਟ",
    [LangKeys.item_stock_sales_report_desc]: "ਉਤਪਾਦਾਂ ਅਤੇ ਸੇਵਾਵਾਂ ਦੇ ਸਟਾਕ ਅਤੇ ਵਿਕਰੀ ਦਾ ਵੇਰਵਾ",
    [LangKeys.select_party]: "ਪਾਰਟੀ ਚੁਣੋ",
    [LangKeys.search_placeholder]: "ਨਾਮ ਜਾਂ ਮੋਬਾਈਲ ਨਾਲ ਖੋਜੋ...",
    [LangKeys.back_to_dashboard]: "ਰਿਪੋਰਟ ਮੀਨੂ 'ਤੇ ਵਾਪਸ ਜਾਓ",
    [LangKeys.loading_report_data]: "ਰਿਪੋਰਟ ਡੇਟਾ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
    [LangKeys.no_parties_found]: "ਕੋਈ ਪਾਰਟੀ ਨਹੀਂ ਮਿਲੀ।",
    [LangKeys.select_customer]: "ਰਿਪੋਰਟ ਦੇਖਣ ਲਈ ਗਾਹਕ ਚੁਣੋ",
    [LangKeys.select_supplier]: "ਰਿਪੋਰਟ ਦੇਖਣ ਲਈ ਸਪਲਾਇਰ ਚੁਣੋ",
    [LangKeys.premium_feature]: "ਪ੍ਰੀਮੀਅਮ ਫੀਚਰ",
    [LangKeys.premium_lock_desc]: "ਪ੍ਰੋਫੈਸ਼ਨਲ ਬਿਲਿੰਗ, ਵਿਕਰੀ/ਖਰੀਦ ਇਨਵੌਇਸ ਰਿਪੋਰਟਾਂ, ਡੇਬੁੱਕ ਸਟੇਟਮੈਂਟਾਂ ਅਤੇ ਇਨਵੈਂਟਰੀ ਸਾਰਾਂਸ਼ਾਂ ਨੂੰ ਅਨਲੌਕ ਕਰੋ।",
    [LangKeys.upgrade_to_premium]: "ਵਿਗਿਆਪਨ ਮੁਕਤ+ / ਪ੍ਰੀਮੀਅਮ ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ 🚀",
  // PREMIUM
  [LangKeys.plan_standard_name]: "ਸਟੈਂਡਰਡ (ਵਿਗਿਆਪਨ-ਮੁਕਤ)",
  [LangKeys.plan_ads_free_name]: "ਵਿਗਿਆਪਨ-ਮੁਕਤ +",
  [LangKeys.plan_premium_name]: "ਪ੍ਰੀਮੀਅਮ",
  [LangKeys.plan_recommended_tag]: "ਸਿਫਾਰਸ਼ ਕੀਤਾ ਪਲਾਨ",
  [LangKeys.plan_duration_30_days]: "30 ਦਿਨਾਂ ਲਈ",
  [LangKeys.plan_duration_180_days]: "180 ਦਿਨਾਂ (6 ਮਹੀਨੇ) ਲਈ",
  [LangKeys.plan_duration_365_days]: "365 ਦਿਨਾਂ (1 ਸਾਲ) ਲਈ",
  [LangKeys.plan_duration_30_days_badge]: "30 ਦਿਨ",
  [LangKeys.plan_save_20_percent]: "ਬੱਚਤ ~20%",
  [LangKeys.plan_best_value_badge]: "ਵਧੀਆ ਮੁੱਲ",
  [LangKeys.plan_best_value_plan_tag]: "ਬੈਸਟ ਵੈਲਿਊ ਪਲਾਨ",
  [LangKeys.plan_most_popular_save]: "ਸਭ ਤੋਂ ਪ੍ਰਸਿੱਧ • ₹{amount} ਦੀ ਬੱਚਤ",
  [LangKeys.plan_save_amount_tag]: "₹{amount} ਦੀ ਬੱਚਤ",
  [LangKeys.duration_1_month]: "1 ਮਹੀਨਾ",
  [LangKeys.duration_6_months]: "6 ਮਹੀਨੇ",
  [LangKeys.duration_12_months]: "12 ਮਹੀਨੇ",
  [LangKeys.plan_save_text]: "ਬਚਤ ਕਰੋ",
  [LangKeys.benefit_no_ads]: "ਕੋਈ ਵਿਗਿਆਪਨ ਨਹੀਂ (100% ਵਿਗਿਆਪਨ-ਮੁਕਤ ਅਨੁਭਵ)",
  [LangKeys.benefit_support]: "24/7 ਪ੍ਰਾਥਮਿਕ ਗਾਹਕ ਸਹਾਇਤਾ",
  [LangKeys.benefit_all_ads_free]: "Ads Free + ਪਲਾਨ ਦੇ ਸਾਰੇ ਫਾਇਦੇ",
  [LangKeys.benefit_multiple_devices]: "ਇੱਕੋ ਸਮੇਂ ਕਈ ਡਿਵਾਈਸਾਂ ‘ਤੇ ਲਾਗਇਨ ਕਰੋ",
  [LangKeys.benefit_desktop_access]: "ਕੰਪਿਊਟਰ/ਡੈਸਕਟਾਪ ‘ਤੇ ਐਕਸੈੱਸ",
  [LangKeys.benefit_create_bills]: "ਬਿੱਲ ਬਣਾਓ (ਸਧਾਰਣ ਬਿੱਲ, GST ਬਿੱਲ)",
  [LangKeys.benefit_defaulters_list]: "ਇੱਕ ਕਲਿੱਕ ਨਾਲ ਬਕਾਇਆਦਾਰਾਂ ਦੀ ਸੂਚੀ ਵੇਖੋ",
  [LangKeys.benefit_organize_lists]: "ਲਿਸਟਾਂ ਨਾਲ ਆਪਣੇ ਖਾਤਿਆਂ ਨੂੰ ਠੀਕ ਕਰੋ",
  [LangKeys.benefit_manage_stocks]: "ਸਟਾਕ ਮੈਨੇਜ ਕਰੋ (ਲੈਣ-ਦੇਣ ਨਾਲ ਆਈਟਮ ਜੋੜੋ)",
  [LangKeys.benefit_financial_reports]: "ਪ੍ਰੀਮੀਅਮ ਵਿੱਤੀ ਰਿਪੋਰਟਾਂ (PDF/Excel)",
  [LangKeys.benefit_dual_backup]: "ਸੁਰੱਖਿਅਤ ਲੋਕਲ ਅਤੇ ਕਲਾਉਡ ਸਟੋਰੇਜ ‘ਤੇ ਡੁਅਲ ਬੈਕਅੱਪ",
  [LangKeys.benefit_unlimited_entry]: "ਕੈਸ਼ਬੁੱਕ/ਖਾਤੇ ਵਿੱਚ ਅਸੀਮਤ ਐਂਟਰੀਆਂ",
  [LangKeys.benefit_unlimited_transactions]: "ਅਨਲਿਮਿਟੇਡ ਲੈਣ-ਦੇਣ (Unlimited Transactions)",
  [LangKeys.benefit_unlimited_sms]: "ਅਨਲਿਮਿਟੇਡ SMS",
  [LangKeys.benefit_dairy_management]: "ਡੇਅਰੀ ਸੁਵਿਧਾਵਾਂ (ਦੁੱਧ ਦੇ ਰਿਕਾਰਡ, ਰੇਟ ਚਾਰਟ, ਬਿੱਲ)",
  [LangKeys.benefit_refer_earn]: "ਰੈਫਰ ਕਰੋ ਅਤੇ ਕਮਾਓ (ਮੁਫ਼ਤ ਰੀਚਾਰਜ ਦੀ ਮਿਆਦ)",
  [LangKeys.my_subscription_title]: "ਮੇਰੀ ਸਬਸਕ੍ਰਿਪਸ਼ਨ",
  [LangKeys.premium_plans_title]: "ਸਾਡੇ ਪ੍ਰੀਮੀਅਮ ਪਲਾਨ",
  [LangKeys.active_badge_label]: "ਸਰਗਰਮ",
  [LangKeys.expires_on_label]: "{date} ਨੂੰ ਸਮਾਪਤ ਹੋਵੇਗਾ",
  [LangKeys.expired_badge_label]: "ਸਮਾਪਤ",
  [LangKeys.expired_on_label]: "{date} ਨੂੰ ਸਮਾਪਤ ਹੋ ਗਿਆ",
  [LangKeys.extend_plan_label]: "ਪਲਾਨ ਵਧਾਓ (+{days} ਦਿਨ)",
  [LangKeys.days_remaining_label]: "({days} ਦਿਨ ਬਾਕੀ)",
  [LangKeys.secure_checkout_label]: "100% ਸੁਰੱਖਿਅਤ SSL ਭੁਗਤਾਨ",
  [LangKeys.upgrade_button]: "ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
  [LangKeys.downgrade_button]: "ਡਾਊਨਗ੍ਰੇਡ ਕਰੋ",

  // Business Profile & Marketplace
  [LangKeys.biz_profile__marketplace_settings]: 'ਆਨਲਾਈਨ ਸਟੋਰ ਸੈਟਿੰਗਜ਼ (Moxpal Market)',
  [LangKeys.biz_profile__online_business_toggle]: 'ਆਨਲਾਈਨ ਕਾਰੋਬਾਰ ਚਾਲੂ ਰੱਖੋ',
  [LangKeys.biz_profile__online_business_active]: 'ਕਾਰੋਬਾਰ ਆਨਲਾਈਨ ਚਾਲੂ ਹੈ (Active)',
  [LangKeys.biz_profile__online_business_offline]: 'ਕਾਰੋਬਾਰ ਆਨਲਾਈਨ ਬੰਦ ਹੈ (Offline)',
  [LangKeys.biz_profile__gps_pending_badge]: 'ਆਨਲਾਈਨ ਚਾਲੂ ਹੈ (GPS ਸੈੱਟ ਕਰੋ)',
  [LangKeys.biz_profile__online_business_sub_active]: 'ਚਾਲੂ ਕਰਨ ਤੋਂ ਬਾਅਦ 1-ਕਲਿੱਕ ਵਿੱਚ ਰਾਜ, ਜ਼ਿਲ੍ਹਾ, ਇਲਾਕਾ ਅਤੇ ਪਿਨਕੋਡ ਭਰੋ ਅਤੇ GPS ਸੈੱਟ ਕਰੋ ਤਾਂ ਜੋ ਦੁਕਾਨ ਗਾਹਕਾਂ ਨੂੰ ਦਿਖ ਸਕੇ।',
  [LangKeys.biz_profile__online_business_sub_offline]: 'ਕਾਰੋਬਾਰ ਨੂੰ ਆਨਲਾਈਨ ਚਾਲੂ ਕਰੋ ਤਾਂ ਜੋ ਆਸ-ਪਾਸ ਦੇ ਗਾਹਕ ਲੋਕਲ ਮਾਰਕੀਟ ਵਿੱਚ ਤੁਹਾਡੇ ਉਤਪਾਦ ਅਤੇ ਸੇਵਾਵਾਂ ਲੱਭ ਸਕਣ।',
  [LangKeys.biz_profile__know_benefits_btn]: '💡 ਇਸਦੇ ਫਾਇਦੇ ਅਤੇ ਨਿਯਮ ਜਾਣੋ',
  [LangKeys.biz_profile__benefits_modal_title]: 'ਆਨਲਾਈਨ ਕਾਰੋਬਾਰ ਦੇ ਫਾਇਦੇ ਅਤੇ ਪੂਰੀ ਜਾਣਕਾਰੀ',
  [LangKeys.biz_profile__benefits_step1_title]: '1. ਇਸਨੂੰ ਚਾਲੂ ਕਰਨ ਨਾਲ ਕੀ ਹੋਵੇਗਾ?',
  [LangKeys.biz_profile__benefits_step1_desc]: 'ਤੁਹਾਡਾ ਕਾਰੋਬਾਰ, ਉਤਪਾਦ ਅਤੇ ਸੇਵਾਵਾਂ ਤੁਰੰਤ ਲੋਕਲ ਮਾਰਕੀਟ ਵਿੱਚ ਲਾਈਵ ਹੋ ਜਾਣਗੀਆਂ। ਆਸ-ਪਾਸ ਦੇ ਸਾਰੇ ਗਾਹਕ ਤੁਹਾਨੂੰ ਲੱਭ ਸਕਣਗੇ।',
  [LangKeys.biz_profile__benefits_step2_title]: '2. ਤੁਹਾਨੂੰ ਕੀ-ਕੀ ਕਰਨਾ ਹੈ?',
  [LangKeys.biz_profile__benefits_step2_desc]: '• ਨੀਲੇ ਬਟਨ (⚡ 1-ਕਲਿੱਕ) ਨਾਲ ਰਾਜ, ਜ਼ਿਲ੍ਹਾ, ਇਲਾਕਾ, ਪਿਨਕੋਡ ਅਤੇ GPS ਸੈੱਟ ਕਰੋ।\n• ਆਪਣੇ ਉਤਪਾਦ ਜਾਂ ਸੇਵਾਵਾਂ ਸ਼ਾਮਲ ਕਰੋ।',
  [LangKeys.biz_profile__benefits_step3_title]: '3. ਇਸਦੇ ਕੀ ਫਾਇਦੇ ਮਿਲਣਗੇ?',
  [LangKeys.biz_profile__benefits_step3_desc]: '• 0% ਕਮਿਸ਼ਨ (100% ਮੁਫ਼ਤ) — ਕੋਈ ਵਿਚੋਲਾ ਨਹੀਂ।\n• ਸਿੱਧੇ WhatsApp ਅਤੇ ਕਾਲ ‘ਤੇ ਗਾਹਕਾਂ ਤੋਂ ਆਰਡਰ ਪ੍ਰਾਪਤ ਕਰੋ।\n• 24 ਘੰਟੇ ਖੁੱਲ੍ਹੀ ਡਿਜੀਟਲ ਦੁਕਾਨ।',
  [LangKeys.biz_profile__benefits_btn_got_it]: 'ਸਮਝ ਗਿਆ, ਧੰਨਵਾਦ 👍',
  [LangKeys.biz_profile__autofill_btn_title]: '⚡ 1-ਕਲਿੱਕ ਵਿੱਚ ਪੂਰਾ ਪਤਾ ਆਟੋ ਭਰੋ',
  [LangKeys.biz_profile__autofill_btn_sub]: 'GPS ਨਾਲ ਰਾਜ, ਜ਼ਿਲ੍ਹਾ, ਪਿੰਡ ਅਤੇ ਪਿਨਕੋਡ ਆਪੇ ਭਰੋ',
  [LangKeys.biz_profile__autofill_searching]: 'ਲੋਕੇਸ਼ਨ ਲੱਭੀ ਜਾ ਰਹੀ ਹੈ...',
  [LangKeys.biz_profile__state_lbl]: 'ਰਾਜ (State)',
  [LangKeys.biz_profile__state_add]: 'ਰਾਜ ਸ਼ਾਮਲ ਕਰੋ',
  [LangKeys.biz_profile__state_placeholder]: 'ਜਿਵੇਂ Punjab, Haryana, Rajasthan...',
  [LangKeys.biz_profile__city_lbl]: 'ਸ਼ਹਿਰ / ਜ਼ਿਲ੍ਹਾ (City / District)',
  [LangKeys.biz_profile__city_add]: 'ਸ਼ਹਿਰ ਸ਼ਾਮਲ ਕਰੋ',
  [LangKeys.biz_profile__city_placeholder]: 'ਜਿਵੇਂ Amritsar, Ludhiana, Jalandhar...',
  [LangKeys.biz_profile__area_lbl]: 'ਪਿੰਡ / ਇਲਾਕਾ (Area / Village)',
  [LangKeys.biz_profile__area_add]: 'ਇਲਾਕਾ ਸ਼ਾਮਲ ਕਰੋ',
  [LangKeys.biz_profile__area_placeholder]: 'ਜਿਵੇਂ Model Town, Civil Lines...',
  [LangKeys.biz_profile__pincode_lbl]: 'ਪਿਨਕੋਡ (Pincode)',
  [LangKeys.biz_profile__pincode_add]: 'ਪਿਨਕੋਡ ਸ਼ਾਮਲ ਕਰੋ',
  [LangKeys.biz_profile__pincode_placeholder]: '6 ਅੰਕਾਂ ਦਾ ਪਿਨਕੋਡ ਦਾਖਲ ਕਰੋ',
  [LangKeys.biz_profile__tagline_lbl]: 'ਕਾਰੋਬਾਰ ਦੀ ਟੈਗਲਾਈਨ/ਵੇਰਵਾ',
  [LangKeys.biz_profile__tagline_add]: 'ਟੈਗਲਾਈਨ ਸ਼ਾਮਲ ਕਰੋ',
  [LangKeys.biz_profile__tagline_placeholder]: 'ਜਿਵੇਂ ਸਾਡੇ ਕੋਲ ਤਾਜ਼ਾ ਅਤੇ ਸ਼ੁੱਧ ਸਾਮਾਨ ਮਿਲਦਾ ਹੈ',
  [LangKeys.biz_profile__gps_lbl]: 'ਕਾਰੋਬਾਰ ਦੀ GPS ਲੋਕੇਸ਼ਨ',
  [LangKeys.biz_profile__gps_not_set]: 'ਲੋਕੇਸ਼ਨ ਅਜੇ ਸੈੱਟ ਨਹੀਂ ਹੈ',
  [LangKeys.biz_profile__gps_update_btn]: 'ਅੱਪਡੇਟ ਕਰੋ',
  [LangKeys.biz_profile__gps_get_btn]: 'GPS ਲੋਕੇਸ਼ਨ ਲਵੋ',
  [LangKeys.biz_profile__gps_searching]: 'ਲੱਭ ਰਹੇ ਹਾਂ...',
  [LangKeys.biz_profile__gps_live_warning]: '⚠️ ਸਟੋਰ ਆਨਲਾਈਨ ਹੈ ਪਰ GPS ਸੈੱਟ ਨਹੀਂ ਹੈ! ਕਿਰਪਾ ਕਰਕੇ ⚡ 1-ਕਲਿੱਕ ਬਟਨ ਨਾਲ GPS ਸੈੱਟ ਕਰੋ ਤਾਂ ਜੋ ਗਾਹਕਾਂ ਨੂੰ ਦੁਕਾਨ ਦਿਖੇ।',
  [LangKeys.biz_profile__gps_turn_on_toast]: 'ਕਿਰਪਾ ਕਰਕੇ ਬ੍ਰਾਊਜ਼ਰ/ਫੋਨ ਦੀ GPS ਲੋਕੇਸ਼ਨ ਚਾਲੂ ਕਰੋ',
  [LangKeys.biz_profile__gps_permission_denied_toast]: 'ਲੋਕੇਸ਼ਨ ਦੀ ਇਜਾਜ਼ਤ ਨਹੀਂ ਦਿੱਤੀ ਗਈ',
  [LangKeys.biz_profile__gps_permission_settings_toast]: 'ਕਿਰਪਾ ਕਰਕੇ ਸੈਟਿੰਗਜ਼ ਵਿੱਚ ਜਾ ਕੇ Location Permission ਚਾਲੂ ਕਰੋ',
  [LangKeys.biz_profile__gps_autofill_success_toast]: 'GPS ਨਾਲ ਪੂਰਾ ਪਤਾ ਆਪੇ ਭਰਿਆ ਗਿਆ!',
  [LangKeys.biz_profile__gps_error_toast]: 'ਲੋਕੇਸ਼ਨ ਲੈਣ ਵਿੱਚ ਗਲਤੀ',
  [LangKeys.biz_market_video_guide_title]: 'ਲੋਕਲ ਮਾਰਕੀਟ ਵਿੱਚ ਦੁਕਾਨ ਆਨਲਾਈਨ ਕਿਵੇਂ ਕਰੀਏ?',
  [LangKeys.biz_market_video_guide_sub]: '1 ਮਿੰਟ ਦਾ ਵੀਡੀਓ ਦੇਖੋ ਅਤੇ ਸਿੱਖੋ • YouTube Guide',
  [LangKeys.item_video_guide_btn_sub]: "ਸਟੋਰ ਅਤੇ ਉਤਪਾਦ ਆਨਲਾਈਨ ਐਕਟਿਵ ਕਰਨ ਦੀ ਗਾਈਡ",
  [LangKeys.service_video_guide_btn_sub]: "ਕੰਮ ਅਤੇ ਦੁਕਾਨ ਆਨਲਾਈਨ ਐਕਟਿਵ ਕਰਨ ਦੀ ਗਾਈਡ",
  [LangKeys.item_marketplace_title]: "ਆਨਲਾਈਨ ਬਾਜ਼ਾਰ (Marketplace)",
  [LangKeys.item_marketplace_sub_active]: "ਇਹ ਪ੍ਰੋਡਕਟ ਨੇੜਲੇ ਗਾਹਕਾਂ ਨੂੰ ਔਨਲਾਈਨ ਦਿਖੇਗਾ, ਉਹ ਤੁਹਾਡੇ ਨਾਲ ਸਿੱਧਾ ਸੰਪਰਕ ਕਰ ਸਕਣਗੇ ਅਤੇ WhatsApp ਤੇ ਆਰਡਰ ਕਰ ਸਕਣਗੇ।",
  [LangKeys.item_marketplace_sub_inactive]: "ਇਹ ਉਤਪਾਦ ਸਿਰਫ਼ ਤੁਹਾਡੇ ਨਿੱਜੀ ਖਾਤੇ ਵਿੱਚ ਰਹੇਗਾ।",
  [LangKeys.service_marketplace_sub_active]: "ਇਹ ਸੇਵਾ ਨੇੜਲੇ ਗਾਹਕਾਂ ਨੂੰ ਔਨਲਾਈਨ ਦਿਖੇਗੀ, ਉਹ ਤੁਹਾਡੇ ਨਾਲ ਸਿੱਧਾ ਸੰਪਰਕ ਕਰ ਸਕਣਗੇ ਅਤੇ WhatsApp/ਕਾਲ ਤੇ ਬੁਕਿੰਗ ਕਰ ਸਕਣਗੇ।",
  [LangKeys.service_marketplace_sub_inactive]: "ਇਹ ਸੇਵਾ ਸਿਰਫ਼ ਤੁਹਾਡੀ ਦੁਕਾਨ/ਫਰਮ ਦੇ ਨਿੱਜੀ ਖਾਤੇ ਵਿੱਚ ਰਹੇਗੀ।",
  [LangKeys.item_category_lbl]: "ਸ਼੍ਰੇਣੀ (Category)",
  [LangKeys.change_btn]: "ਬਦਲੋ",
  [LangKeys.item_discount_price_lbl]: "ਆਫਰ / ਛੂਟ ਮੁੱਲ (₹) (ਵਿਕਲਪਿਕ)",
  [LangKeys.item_discount_price_hint]: "ਉਦਾ. 450",
  [LangKeys.service_discount_price_lbl]: "ਆਫਰ / ਛੂਟ ਸਰਵਿਸ ਚਾਰਜ (₹) (ਵਿਕਲਪਿਕ)",
  [LangKeys.service_discount_price_hint]: "ਉਦਾ. 750",
  [LangKeys.item_desc_lbl]: "ਵੇਰਵਾ (Short Description) (ਵਿਕਲਪਿਕ)",
  [LangKeys.item_desc_hint]: "ਉਤਪਾਦ ਦਾ ਬ੍ਰਾਂਡ, ਮਾਡਲ, ਰੰਗ, ਸਾਈਜ਼ ਅਤੇ ਮੁੱਖ ਫੀਚਰ ਲਿਖੋ (ਗੂਗਲ ਸਰਚ ਵਿੱਚ ਮਦਦ ਮਿਲੇਗੀ)...",
  [LangKeys.service_desc_lbl]: "ਸਰਵਿਸ ਦਾ ਵੇਰਵਾ (Description) (ਵਿਕਲਪਿਕ)",
  [LangKeys.service_desc_hint]: "ਸਰਵਿਸ ਦੇ ਮੁੱਖ ਫੀਚਰ, ਕੰਮ ਦਾ ਤਰੀਕਾ ਅਤੇ ਤਜਰਬਾ ਲਿਖੋ (ਗੂਗਲ ਸਰਚ ਵਿੱਚ ਮਦਦ ਮਿਲੇਗੀ)...",
  [LangKeys.market_seo_badge]: "ਗੂਗਲ ਖੋਜ ਅਤੇ ਰੈਂਕਿੰਗ",
  [LangKeys.category_picker_title]: "ਸ਼੍ਰੇਣੀ ਚੁਣੋ (Select Category)",
  [LangKeys.category_picker_sub_item]: "ਸਾਮਾਨ ਕਿਸ ਸ਼੍ਰੇਣੀ/ਵਪਾਰ ਦਾ ਹੈ?",
  [LangKeys.category_picker_sub_service]: "ਸੇਵਾ ਕਿਸ ਸ਼੍ਰੇਣੀ/ਕੰਮ ਦੀ ਹੈ?",
  [LangKeys.category_search_hint]: "ਸ਼੍ਰੇਣੀ ਖੋਜੋ (ਉਦਾ. ਕਰਿਆਨਾ, ਦੁੱਧ, ਕੱਪੜੇ...)",
  [LangKeys.no_category_found]: "ਕੋਈ ਸ਼੍ਰੇਣੀ ਨਹੀਂ ਮਿਲੀ",
  [LangKeys.nothing_found_for]: "ਲਈ ਕੁਝ ਨਹੀਂ ਮਿਲਿਆ",
  [LangKeys.cat_title_general]: "ਆਮ ਵਸਤੂਆਂ",
  [LangKeys.cat_sub_general]: "General Products",
  [LangKeys.cat_title_grocery]: "ਕਰਿਆਨਾ, ਰਾਸ਼ਨ ਤੇ ਪ੍ਰੋਵੀਜ਼ਨ",
  [LangKeys.cat_sub_grocery]: "Kirana, Grocery & Provisions",
  [LangKeys.cat_title_dairy]: "ਡੇਅਰੀ, ਦੁੱਧ, ਘਿਓ ਤੇ ਪਨੀਰ",
  [LangKeys.cat_sub_dairy]: "Dairy, Milk, Ghee & Paneer",
  [LangKeys.cat_title_fruits_veg]: "ਫਲ ਤੇ ਤਾਜ਼ੀਆਂ ਸਬਜ਼ੀਆਂ",
  [LangKeys.cat_sub_fruits_veg]: "Fresh Fruits & Vegetables",
  [LangKeys.cat_title_sweets_bakery]: "ਮਿਠਾਈ, ਨਮਕੀਨ ਤੇ ਬੇਕਰੀ",
  [LangKeys.cat_sub_sweets_bakery]: "Sweets, Snacks & Bakery",
  [LangKeys.cat_title_restaurant_food]: "ਹੋਟਲ, ਢਾਬਾ ਤੇ ਰੈਸਟੋਰੈਂਟ",
  [LangKeys.cat_sub_restaurant_food]: "Hotel, Food & Restaurant",
  [LangKeys.cat_title_pharmacy_medical]: "ਮੈਡੀਕਲ, ਦਵਾਈਆਂ ਤੇ ਸਿਹਤ ਸੰਭਾਲ",
  [LangKeys.cat_sub_pharmacy_medical]: "Pharmacy & Healthcare",
  [LangKeys.cat_title_agriculture_seeds]: "ਖੇਤੀਬਾੜੀ, ਖਾਦ, ਬੀਜ ਤੇ ਦਵਾਈਆਂ",
  [LangKeys.cat_sub_agriculture_seeds]: "Agri, Seeds & Fertilizer",
  [LangKeys.cat_title_animal_feed]: "ਪਸ਼ੂ ਆਹਾਰ, ਖਲ ਤੇ ਫੀਡ",
  [LangKeys.cat_sub_animal_feed]: "Cattle & Animal Feed",
  [LangKeys.cat_title_electronics_mobile]: "ਮੋਬਾਈਲ, ਲੈਪਟਾਪ ਤੇ ਕੰਪਿਊਟਰ",
  [LangKeys.cat_sub_electronics_mobile]: "Electronics, Mobile & IT",
  [LangKeys.cat_title_electrical_appliances]: "ਇਲੈਕਟ੍ਰੀਕਲ ਤੇ ਘਰੇਲੂ ਉਪਕਰਣ",
  [LangKeys.cat_sub_electrical_appliances]: "Electricals & Appliances",
  [LangKeys.cat_title_clothing_garments]: "ਕੱਪੜੇ, ਸੂਟ ਤੇ ਰੈਡੀਮੇਡ",
  [LangKeys.cat_sub_clothing_garments]: "Garments, Sarees & Apparel",
  [LangKeys.cat_title_footwear_shoes]: "ਜੁੱਤੇ, ਚੱਪਲਾਂ ਤੇ ਫੁਟਵੀਅਰ",
  [LangKeys.cat_sub_footwear_shoes]: "Footwear & Shoes",
  [LangKeys.cat_title_hardware_sanitary]: "ਹਾਰਡਵੇਅਰ, ਸੈਨੇਟਰੀ ਤੇ ਔਜ਼ਾਰ",
  [LangKeys.cat_sub_hardware_sanitary]: "Hardware, Sanitary & Tools",
  [LangKeys.cat_title_building_materials]: "ਬਿਲਡਿੰਗ ਮਟੀਰੀਅਲ ਤੇ ਸੀਮਿੰਟ",
  [LangKeys.cat_sub_building_materials]: "Building Materials & Cement",
  [LangKeys.cat_title_automobile_parts]: "ਆਟੋ ਪਾਰਟਸ ਤੇ ਸਪੇਅਰਜ਼",
  [LangKeys.cat_sub_automobile_parts]: "Automobile & Spares",
  [LangKeys.cat_title_cosmetics_beauty]: "ਕਾਸਮੈਟਿਕਸ, ਬਿਊਟੀ ਤੇ ਸੈਲੂਨ",
  [LangKeys.cat_sub_cosmetics_beauty]: "Beauty, Salon & Cosmetics",
  [LangKeys.cat_title_stationery_books]: "ਕਿਤਾਬਾਂ, ਸਟੇਸ਼ਨਰੀ ਤੇ ਪ੍ਰਿੰਟਿੰਗ",
  [LangKeys.cat_sub_stationery_books]: "Books & Stationery",
  [LangKeys.cat_title_jewellery_gifts]: "ਸੋਨਾ-ਚਾਂਦੀ ਤੇ ਗਹਿਣੇ",
  [LangKeys.cat_sub_jewellery_gifts]: "Jewellery & Gifts",
  [LangKeys.cat_title_furniture_decor]: "ਫਰਨੀਚਰ ਤੇ ਘਰ ਦੀ ਸਜਾਵਟ",
  [LangKeys.cat_sub_furniture_decor]: "Furniture & Home Decor",
  [LangKeys.cat_title_kitchenware_utensils]: "ਬਰਤਨ ਤੇ ਕਿਚਨਵੇਅਰ",
  [LangKeys.cat_sub_kitchenware_utensils]: "Kitchenware & Utensils",
  [LangKeys.cat_title_toys_sports]: "ਖਿਡੌਣੇ ਤੇ ਖੇਡਾਂ",
  [LangKeys.cat_sub_toys_sports]: "Toys & Sports",
  [LangKeys.cat_title_packaging_disposable]: "ਪਲਾਸਟਿਕ ਤੇ ਡਿਸਪੋਜ਼ੇਬਲ ਸਮਾਨ",
  [LangKeys.cat_sub_packaging_disposable]: "Packaging & Disposables",
  [LangKeys.cat_title_tailoring_boutique]: "ਟੇਲਰਿੰਗ ਤੇ ਬੁਟੀਕ",
  [LangKeys.cat_sub_tailoring_boutique]: "Tailoring & Boutique",
  [LangKeys.cat_title_meat_poultry]: "ਮੀਟ, ਮੱਛੀ ਤੇ ਪੋਲਟਰੀ",
  [LangKeys.cat_sub_meat_poultry]: "Meat, Fish & Poultry",
  [LangKeys.cat_title_services_repair]: "ਮੁਰੰਮਤ ਤੇ ਮਿਸਤਰੀ ਸੇਵਾਵਾਂ",
  [LangKeys.cat_sub_services_repair]: "Repair & Services",
  [LangKeys.cat_title_other]: "ਹੋਰ ਸਾਰੀਆਂ ਵਸਤਾਂ ਤੇ ਸੇਵਾਵਾਂ",
  [LangKeys.cat_sub_other]: "Other Products & Services",
  [LangKeys.cat_title_optical_eyewear]: "ਐਨਕਾਂ ਅਤੇ ਆਪਟੀਕਲਜ਼",
  [LangKeys.cat_sub_optical_eyewear]: "Optical & Eyewear",
  [LangKeys.cat_title_pooja_religious]: "ਪੂਜਾ ਸਮੱਗਰੀ ਅਤੇ ਧੂਫ-ਅਗਰਬੱਤੀ",
  [LangKeys.cat_sub_pooja_religious]: "Pooja Items & Essentials",
  [LangKeys.cat_title_watches_accessories]: "ਘੜੀਆਂ ਅਤੇ ਐਕਸੈਸਰੀਜ਼",
  [LangKeys.cat_sub_watches_accessories]: "Watches & Accessories",
  [LangKeys.cat_title_generalservice]: "ਆਮ ਸੇਵਾ (General Service)",
  [LangKeys.cat_sub_generalservice]: "All General Services & Labor",
  [LangKeys.cat_title_electronics_tv_repair]: "ਟੀਵੀ, LED ਤੇ ਇਲੈਕਟ੍ਰੋਨਿਕਸ ਰਿਪੇਅਰ",
  [LangKeys.cat_sub_electronics_tv_repair]: "TV, LED, Music System & Electronics",
  [LangKeys.cat_title_ac_appliances_repair]: "ਏਸੀ, ਫਰਿੱਜ, ਵਾਸ਼ਿੰਗ ਮਸ਼ੀਨ ਤੇ ਗੀਜ਼ਰ",
  [LangKeys.cat_sub_ac_appliances_repair]: "AC, Refrigerator & Home Appliances",
  [LangKeys.cat_title_electrician_wiring]: "ਇਲੈਕਟ੍ਰੀਸ਼ੀਅਨ, ਵਾਇਰਿੰਗ ਤੇ ਪੱਖੇ",
  [LangKeys.cat_sub_electrician_wiring]: "Electrician, Fitting & Rewinding",
  [LangKeys.cat_title_plumbing_sanitary]: "ਪਲੰਬਰ, ਪਾਈਪ ਤੇ ਸੈਨੇਟਰੀ ਫਿਟਿੰਗ",
  [LangKeys.cat_sub_plumbing_sanitary]: "Plumber & Sanitary Fitting",
  [LangKeys.cat_title_tailoring_stitching]: "ਸਿਲਾਈ, ਟੇਲਰਿੰਗ ਤੇ ਬੁਟੀਕ",
  [LangKeys.cat_sub_tailoring_stitching]: "Tailoring, Stitching & Boutique",
  [LangKeys.cat_title_mobile_laptop_repair]: "ਮੋਬਾਈਲ, ਲੈਪਟਾਪ ਤੇ ਕੰਪਿਊਟਰ ਰਿਪੇਅਰ",
  [LangKeys.cat_sub_mobile_laptop_repair]: "Mobile, Laptop & Desktop Service",
  [LangKeys.cat_title_automobile_mechanic]: "ਕਾਰ, ਬਾਈਕ ਸਰਵਿਸ ਤੇ ਵਾਸ਼ਿੰਗ",
  [LangKeys.cat_sub_automobile_mechanic]: "Car, Bike & Auto Mechanic / Washing",
  [LangKeys.cat_title_beauty_parlour_salon]: "ਬਿਊਟੀ ਪਾਰਲਰ, ਸੈਲੂਨ ਤੇ ਮੇਕਓਵਰ",
  [LangKeys.cat_sub_beauty_parlour_salon]: "Beauty Parlour, Salon & Bridal",
  [LangKeys.cat_title_carpenter_woodwork]: "ਤਰਖਾਣ / ਕਾਰਪੇਂਟਰ ਤੇ ਲੱਕੜ ਦਾ ਕੰਮ",
  [LangKeys.cat_sub_carpenter_woodwork]: "Carpenter, Furniture & Woodwork",
  [LangKeys.cat_title_painting_whitewash]: "ਪੇਂਟਿੰਗ, ਪੁੱਟੀ ਤੇ ਰੰਗ ਰੋਗਨ",
  [LangKeys.cat_sub_painting_whitewash]: "Wall Painting, Putty & Polish",
  [LangKeys.cat_title_construction_civil]: "ਮਕਾਨ ਉਸਾਰੀ, ਠੇਕੇਦਾਰ ਤੇ ਮਿਸਤਰੀ",
  [LangKeys.cat_sub_construction_civil]: "Civil Contractor, Mason & Labour",
  [LangKeys.cat_title_agri_motor_tractor]: "ਟਰੈਕਟਰ, ਮੋਟਰ ਤੇ ਪੰਪ ਸਰਵਿਸ",
  [LangKeys.cat_sub_agri_motor_tractor]: "Tractor, Water Pump & Agri Motors",
  [LangKeys.cat_title_cctv_security_install]: "ਸੀਸੀਟੀਵੀ ਤੇ ਸੁਰੱਖਿਆ ਇੰਸਟਾਲੇਸ਼ਨ",
  [LangKeys.cat_sub_cctv_security_install]: "CCTV Camera & Security Fitting",
  [LangKeys.cat_title_cleaning_pest_control]: "ਸਫਾਈ, ਪਾਣੀ ਟੈਂਕੀ ਤੇ ਕੀਟ ਕੰਟਰੋਲ",
  [LangKeys.cat_sub_cleaning_pest_control]: "Deep Cleaning, Water Tank & Pest",
  [LangKeys.cat_title_transport_loading]: "ਟਰਾਂਸਪੋਰਟ, ਲੋਡਿੰਗ ਤੇ ਸ਼ਿਫਟਿੰਗ",
  [LangKeys.cat_sub_transport_loading]: "Transport, Loading & Movers",
  [LangKeys.cat_title_photography_video]: "ਫੋਟੋਗ੍ਰਾਫੀ ਤੇ ਵੀਡੀਓਗ੍ਰਾਫੀ",
  [LangKeys.cat_sub_photography_video]: "Photo, Video & Studio Services",
  [LangKeys.cat_title_events_catering_tent]: "ਟੈਂਟ ਹਾਊਸ, ਕੈਟਰਿੰਗ, ਡੀਜੇ ਤੇ ਸਾਊਂਡ",
  [LangKeys.cat_sub_events_catering_tent]: "Tent, Catering, DJ & Events",
  [LangKeys.cat_title_education_tuition]: "ਕੋਚਿੰਗ, ਟਿਊਸ਼ਨ ਤੇ ਕਲਾਸਾਂ",
  [LangKeys.cat_sub_education_tuition]: "Tuition & Education Classes",
  [LangKeys.cat_title_ca_tax_csc_emitra]: "ਸੀਏ, ਟੈਕਸ ਤੇ ਆਨਲਾਈਨ ਫਾਰਮ ਸੇਵਾ",
  [LangKeys.cat_sub_ca_tax_csc_emitra]: "CA, Tax, CSC, E-Mitra & Online Forms",
  [LangKeys.cat_title_healthcare_clinic_lab]: "ਡਾਕਟਰ, ਕਲੀਨਿਕ ਤੇ ਲੈਬ ਟੈਸਟ",
  [LangKeys.cat_sub_healthcare_clinic_lab]: "Doctor, Nursing & Diagnostics",
  [LangKeys.cat_title_other_service]: "ਹੋਰ ਸਾਰੀਆਂ ਹੁਨਰਮੰਦ ਸੇਵਾਵਾਂ",
  [LangKeys.cat_sub_other_service]: "Other Services & Skilled Work",
  [LangKeys.cat_title_transport_taxi]: "ਟੈਕਸੀ ਅਤੇ ਟੂਰ ਟਰੈਵਲਜ਼",
  [LangKeys.cat_sub_transport_taxi]: "Taxi & Tour Travels",
  [LangKeys.cat_title_legal_advocate]: "ਵਕੀਲ ਅਤੇ ਕਾਨੂੰਨੀ ਸੇਵਾਵਾਂ",
  [LangKeys.cat_sub_legal_advocate]: "Legal & Advocate Services",
  [LangKeys.cat_title_packers_movers]: "ਪੈਕਰਸ ਅਤੇ ਮੂਵਰਸ",
  [LangKeys.cat_sub_packers_movers]: "Packers & Movers",
  [LangKeys.cat_title_printing_flex_banner]: "ਪ੍ਰਿੰਟਿੰਗ ਅਤੇ ਫਲੈਕਸ ਬੋਰਡ",
  [LangKeys.cat_sub_printing_flex_banner]: "Printing & Flex Banner",
  [LangKeys.cat_title_gym_fitness_yoga]: "ਜਿਮ, ਫਿਟਨੈਸ ਅਤੇ ਯੋਗਾ",
  [LangKeys.cat_sub_gym_fitness_yoga]: "Gym, Fitness & Yoga",
  [LangKeys.cat_title_cook_maid_househelp]: "ਕੁੱਕ ਅਤੇ ਘਰੇਲੂ ਮਦਦਗਾਰ",
  [LangKeys.cat_sub_cook_maid_househelp]: "Cook & Domestic Help",
  [LangKeys.item_photo_guide_verified]: "ਫੋਟੋ ਸ਼ਾਮਲ ਕੀਤੀ ਗਈ • Tier-1 ਸਿਖਰਲੀ ਸੂਚੀ",
  [LangKeys.item_photo_guide_why_add]: "ਫੋਟੋ ਕਿਉਂ ਜੋੜੀਏ? (5x ਵੱਧ ਵਿਕਰੀ)",
  [LangKeys.service_photo_guide_why_add]: "ਫੋਟੋ ਕਿਉਂ ਜੋੜੀਏ? (5x ਵੱਧ ਬੁਕਿੰਗ)",
  [LangKeys.item_photo_guide_desc]: "ਸਾਫ਼ ਰੌਸ਼ਨੀ ਅਤੇ ਬਿਨਾਂ ਧੁੰਦਲੀ PNG/JPG ਫੋਟੋ ਲਗਾਓ। ਫੋਟੋ ਵਾਲੇ ਉਤਪਾਦ ਆਨਲਾਈਨ ਬਜ਼ਾਰ ਵਿੱਚ ਸਭ ਤੋਂ ਉੱਪਰ (Tier-1) ਦਿਖਾਈ ਦਿੰਦੇ ਹਨ।",
  [LangKeys.service_photo_guide_desc]: "ਆਪਣੇ ਕੰਮ, ਸੰਦਾਂ ਜਾਂ ਦੁਕਾਨ ਦੀ ਸਾਫ਼ PNG/JPG ਫੋਟੋ ਲਗਾਓ। ਫੋਟੋ ਵਾਲੀਆਂ ਸੇਵਾਵਾਂ ਨੇੜਲੇ ਗਾਹਕਾਂ ਨੂੰ ਸਭ ਤੋਂ ਉੱਪਰ (Tier-1) ਦਿਖਾਈ ਦਿੰਦੀਆਂ ਹਨ।",
  [LangKeys.item_video_guide_btn_title]: "ਆਨਲਾਈਨ ਲਿਸਟਿੰਗ ਸਿੱਖੋ (5 ਮਿੰਟ ਵੀਡੀਓ)",
  [LangKeys.service_video_guide_btn_title]: "ਸਰਵਿਸ ਲਿਸਟਿੰਗ ਸਿੱਖੋ (5 ਮਿੰਟ ਵੀਡੀਓ)",
  [LangKeys.market_format_bold]: "𝗕 ਬੋਲਡ (*ਨਾਮ*)",
  [LangKeys.market_format_bullet]: "• ਬੁਲੇਟ ਪੁਆਇੰਟ",
  [LangKeys.market_format_highlight]: "⭐ ਮੁੱਖ ਖਾਸੀਅਤ",
  [LangKeys.market_format_warranty_item]: "📦 ਵਾਰੰਟੀ / ਵੇਰਵਾ",
  [LangKeys.market_format_warranty_service]: "📦 ਵਾਰੰਟੀ / ਗਾਰੰਟੀ",
  [LangKeys.market_format_template_item]: "⚡ ਤਿਆਰ ਬਲਾਗ ਟੈਂਪਲੇਟ",
  [LangKeys.market_format_template_service]: "⚡ ਤਿਆਰ ਸਰਵਿਸ ਟੈਂਪਲੇਟ",
  [LangKeys.market_seo_tip_item]: "ਵਿਸਤ੍ਰਿਤ ਵੇਰਵਾ ਲਿਖਣ ਨਾਲ ਤੁਹਾਡਾ ਉਤਪਾਦ ਗੂਗਲ ਸਰਚ ਅਤੇ ਔਨਲਾਈਨ ਮਾਰਕੀਟ ਵਿੱਚ ਤੇਜ਼ੀ ਨਾਲ ਗਾਹਕਾਂ ਨੂੰ ਦਿਖੇਗਾ।",
  [LangKeys.market_seo_tip_service]: "ਵਿਸਤ੍ਰਿਤ ਵੇਰਵਾ ਲਿਖਣ ਨਾਲ ਤੁਹਾਡੀ ਸਰਵਿਸ ਗੂਗਲ ਸਰਚ ਅਤੇ ਔਨਲਾਈਨ ਮਾਰਕੀਟ ਵਿੱਚ ਤੇਜ਼ੀ ਨਾਲ ਗਾਹਕਾਂ ਨੂੰ ਦਿਖੇਗੀ।",
  [LangKeys.crop_photo_title]: "ਫੋਟੋ ਕ੍ਰੌਪ ਅਤੇ ਐਡਜਸਟ ਕਰੋ",
  [LangKeys.crop_product_photo]: "ਉਤਪਾਦ ਫੋਟੋ ਕ੍ਰੌਪ ਅਤੇ ਐਡਜਸਟ ਕਰੋ",
  [LangKeys.crop_service_photo]: "ਸਰਵਿਸ ਫੋਟੋ ਕ੍ਰੌਪ ਅਤੇ ਐਡਜਸਟ ਕਰੋ",
  [LangKeys.crop_drag_hint]: "ਉਂਗਲ ਜਾਂ ਮਾਊਸ ਨਾਲ ਫੋਟੋ ਹਿਲਾਓ / ਡ੍ਰੈਗ ਕਰੋ",
  [LangKeys.crop_rotate_left]: "90° ਖੱਬੇ",
  [LangKeys.crop_rotate_right]: "90° ਸੱਜੇ",
  [LangKeys.crop_reset]: "ਰੀਸੈੱਟ",
  [LangKeys.crop_ratio_square]: "1:1 (ਵਰਗਾਕਾਰ)",
  [LangKeys.crop_ratio_standard]: "4:3 (ਸਟੈਂਡਰਡ)",
  [LangKeys.crop_ratio_free]: "Free (ਮੁਕਤ)",
  [LangKeys.crop_save_done]: "ਕ੍ਰੌਪ ਅਤੇ ਸੇਵ ਕਰੋ (Done)",
  [LangKeys.crop_compressing]: "ਕੰਪ੍ਰੈੱਸ ਹੋ ਰਿਹਾ ਹੈ...",
  [LangKeys.item_sales_report]: "ਆਈਟਮ ਵਿਕਰੀ ਰਿਪੋਰਟ",
  [LangKeys.profit]: "ਲਾਭ",
  [LangKeys.loss]: "ਨੁਕਸਾਨ",
  [LangKeys.total_qty_sold]: "ਕੁੱਲ ਵੇਚੀ ਮਾਤਰਾ",
  [LangKeys.sold]: "ਵੇਚਿਆ",
  [LangKeys.bought]: "ਖਰੀਦਿਆ",
  [LangKeys.units]: "Units",
  [LangKeys.nos]: "NOS",
  [LangKeys.party_or_details]: "ਪਾਰਟੀ / ਵੇਰਵੇ",
  [LangKeys.report_copied_clipboard]: "ਰਿਪੋਰਟ ਦਾ ਵੇਰਵਾ ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਹੋ ਗਿਆ ਹੈ!",
  [LangKeys.party]: "ਪਾਰਟੀ",
  [LangKeys.sale]: "ਵਿਕਰੀ",
  [LangKeys.purchase]: "ਖਰੀਦ",
  [LangKeys.expense]: "ਖਰਚਾ",
  [LangKeys.ai_support_btn]: "AI ਸਹਾਇਤਾ ਨਾਲ ਤੁਰੰਤ ਚੈਟ ਕਰੋ (24x7 Live)",
  [LangKeys.ai_support_title]: "Moxpal AI ਸਪੋਰਟ",
  [LangKeys.ai_support_online_status]: "● 24x7 ਤੁਰੰਤ ਸਹਾਇਤਾ",
  [LangKeys.ai_support_welcome_msg]: "ਨਮਸਤੇ! 🙏 ਮੈਂ *Moxpal Khata* ਦਾ ਸਮਾਰਟ AI ਸਹਾਇਕ ਹਾਂ।\\n\\nਮੈਂ ਤੁਹਾਡੇ ਖਾਤੇ, ਬਿਲਿੰਗ, ਡੇਅਰੀ ਪਾਸਬੁੱਕ ਜਾਂ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਪਲਾਨ ਨਾਲ ਸਬੰਧਤ ਸਾਰੇ ਸਵਾਲਾਂ ਵਿੱਚ ਮਦਦ ਕਰਨ ਲਈ ਤਿਆਰ ਹਾਂ। ਤੁਸੀਂ ਕੀ ਜਾਣਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
  [LangKeys.ai_support_input_hint]: "ਆਪਣਾ ਸਵਾਲ ਜਾਂ ਸਮੱਸਿਆ ਇੱਥੇ ਪੁੱਛੋ...",
  [LangKeys.ai_support_typing]: "AI ਸਹਾਇਕ ਜਵਾਬ ਲਿਖ ਰਿਹਾ ਹੈ...",
  [LangKeys.ai_support_copied]: "ਸੁਨੇਹਾ ਕਾਪੀ ਹੋ ਗਿਆ",
  [LangKeys.ai_support_net_error]: "ਇੰਟਰਨੈੱਟ ਕਨੈਕਸ਼ਨ ਵਿੱਚ ਸਮੱਸਿਆ ਆ ਰਹੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਨੈੱਟਵਰਕ ਚੈੱਕ ਕਰੋ।",
  [LangKeys.ai_support_server_error]: "ਸਰਵਰ ਨਾਲ ਜੁੜਨ ਵਿੱਚ ਸਮੱਸਿਆ ਆਈ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ WhatsApp ਤੇ ਸੰਪਰਕ ਕਰੋ।",
  [LangKeys.ai_support_sugg_plan]: "💎 ਪਲਾਨ ਦੇ ਕੀ ਫਾਇਦੇ ਹਨ?",
  [LangKeys.ai_support_sugg_dairy]: "🥛 ਡੇਅਰੀ ਪਾਸਬੁੱਕ ਕਿਵੇਂ ਵਰਤੀਏ?",
  [LangKeys.ai_support_sugg_party]: "👥 ਨਵਾਂ ਗਾਹਕ/ਖਾਤਾ ਕਿਵੇਂ ਜੋੜੀਏ?",
  [LangKeys.ai_support_sugg_backup]: "💾 ਡਾਟਾ ਬੈਕਅੱਪ ਕਿਵੇਂ ਲਈਏ?",
  [LangKeys.ai_support_sugg_bill]: "🧾 ਨਵਾਂ ਬਿੱਲ ਕਿਵੇਂ ਬਣਾਈਏ?",
  [LangKeys.ai_support_clear_chat]: "ਨਵੀਂ ਗੱਲਬਾਤ ਸ਼ੁਰੂ ਕਰੋ",
  [LangKeys.ai_support_clear_title]: "ਚੈਟ ਇਤਿਹਾਸ ਸਾਫ਼ ਕਰੋ?",
  [LangKeys.ai_support_clear_confirm]: "ਕੀ ਤੁਸੀਂ ਪੁਰਾਣੀ ਗੱਲਬਾਤ ਸਾਫ਼ ਕਰਕੇ ਨਵੀਂ ਚੈਟ ਸ਼ੁਰੂ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
  [LangKeys.help_center_title]: "Moxpal Khata Help Center",
  [LangKeys.help_center_sub]: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲਾਂ, ਟਿਊਟੋਰੀਅਲ ਅਤੇ ਗਾਹਕ ਸਹਾਇਤਾ ਲਈ ਕੇਂਦਰ",
  [LangKeys.help_support_title]: "ਮਦਦ ਅਤੇ ਸਹਾਇਤਾ",
  [LangKeys.help_center_heading]: "Moxpal Khata Help Center",
  [LangKeys.help_center_subheading]: "FAQs, ਟਿਊਟੋਰੀਅਲ ਅਤੇ ਗਾਹਕ ਸਹਾਇਤਾ ਲਈ ਤੁਹਾਡਾ ਵਨ-ਸਟਾਪ ਸੈਂਟਰ",
  [LangKeys.help_ai_title]: "Moxpal AI Support",
  [LangKeys.help_ai_live_badge]: "24x7 LIVE",
  [LangKeys.help_ai_online_status]: "• 24x7 ਤੁਰੰਤ ਸਹਾਇਤਾ",
  [LangKeys.help_ai_desc]: "ਖਾਤਾ, ਬਿਲਿੰਗ, ਇਨਵੈਂਟਰੀ, ਡੇਅਰੀ ਪਾਸਬੁੱਕ ਜਾਂ ਪਲਾਨ ਨਾਲ ਜੁੜੇ ਸਾਰੇ ਸਵਾਲਾਂ ਦੇ ਤੁਰੰਤ AI ਹੱਲ ਪ੍ਰਾਪਤ ਕਰੋ।",
  [LangKeys.help_ai_chat_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.help_whatsapp_title]: "Contact Us (WhatsApp)",
  [LangKeys.help_whatsapp_sub]: "+91 99293 71541 • ਅਧਿਕਾਰਤ ਸਪੋਰਟ ਟੀਮ",
  [LangKeys.help_call_title]: "ਕਾਲ ਹੈਲਪਲਾਈਨ",
  [LangKeys.help_call_number]: "+91 9166277283",
  [LangKeys.help_email_title]: "ਈਮੇਲ ਸਹਾਇਤਾ",
  [LangKeys.help_email_id]: "support@moxpal.com",
  [LangKeys.help_faq_title]: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ (FAQs)",
  [LangKeys.help_faq_1_q]: "ਖਾਤੇ ਵਿੱਚ ਨਵਾਂ ਗਾਹਕ ਜਾਂ ਸਪਲਾਇਰ ਕਿਵੇਂ ਜੋੜੀਏ?",
  [LangKeys.help_faq_1_a]: "ਹੋਮ ਸਕ੍ਰੀਨ \\'ਤੇ \"Add Customer\" ਬਟਨ ਦਬਾਓ, ਨਾਮ ਅਤੇ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ ਅਤੇ ਸੁਰੱਖਿਅਤ ਕਰੋ।",
  [LangKeys.help_faq_2_q]: "ਡੇਅਰੀ ਪਾਸਬੁੱਕ ਵਿੱਚ ਦੁੱਧ ਇਕੱਠਾ ਕਰਨ ਦੀ ਐਂਟਰੀ ਕਿਵੇਂ ਕਰੀਏ?",
  [LangKeys.help_faq_2_a]: "ਡੇਅਰੀ ਸੈਕਸ਼ਨ ਵਿੱਚ ਜਾਓ, \"ਦੁੱਧ ਐਂਟਰੀ\" ਚੁਣੋ, ਫੈਟ/SNF ਜਾਂ ਸਿੱਧਾ ਰੇਟ ਦਰਜ ਕਰਕੇ 1-ਕਲਿੱਕ ਵਿੱਚ ਰਸੀਦ ਭੇਜੋ।",
  [LangKeys.help_faq_3_q]: "ਡਾਟਾ ਬੈਕਅੱਪ ਕਿਵੇਂ ਸੁਰੱਖਿਅਤ ਰਹਿੰਦਾ ਹੈ?",
  [LangKeys.help_faq_3_a]: "ਮੋਕਸਪਾਲ ਖਾਤਾ \\'ਤੇ ਤੁਹਾਡਾ ਸਾਰਾ ਡਾਟਾ ਕਲਾਊਡ ਸਰਵਰ \\'ਤੇ 100% ਏਨਕ੍ਰਿਪਟਡ ਅਤੇ ਸੁਰੱਖਿਅਤ ਰਹਿੰਦਾ ਹੈ।",
  [LangKeys.help_faq_4_q]: "ਗਾਹਕੀ ਪਲਾਨ ਕਿਵੇਂ ਅੱਪਗ੍ਰੇਡ ਕਰੀਏ?",
  [LangKeys.help_faq_4_a]: "ਸੈਟਿੰਗਾਂ ਵਿੱਚ \"ਮੇਰੀ ਗਾਹਕੀ\" \\'ਤੇ ਜਾਓ ਅਤੇ ਆਪਣਾ ਪਸੰਦੀਦਾ ਪਲਾਨ ਚੁਣ ਕੇ ਸੁਰੱਖਿਅਤ ਭੁਗਤਾਨ ਕਰੋ।",
  [LangKeys.help_footer_call_hours]: "ਕਾਲ ਸਪੋਰਟ: ਸੋਮ - ਸ਼ਨੀ (ਸਵੇਰੇ 9:00 ਤੋਂ ਰਾਤ 8:00)",
  [LangKeys.help_footer_ai_hours]: "AI ਚੈਟ ਸਹਾਇਕ: 24 ਘੰਟੇ 365 ਦਿਨ ਤੁਰੰਤ ਸਹਾਇਤਾ",
  [LangKeys.help_footer_branding]: "Moxpal Technologies • 100% ਸੁਰੱਖਿਅਤ ਅਤੇ ਭਰੋਸੇਮੰਦ • Made in India 🇮🇳",
  [LangKeys.help_feature_launch_error]: "ਸਹੂਲਤ ਖੋਲ੍ਹਣ ਵਿੱਚ ਅਸਮਰੱਥ",
};

export default pa;